import * as i1$1 from '@angular/common';
import { CommonModule, isPlatformBrowser, isPlatformServer, NgOptimizedImage, getLocaleFirstDayOfWeek } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule, PLATFORM_ID, Injectable, Inject, Directive, SecurityContext, Input, EventEmitter, forwardRef, Output, ViewEncapsulation, ViewChild, HostListener, Host, Self, Optional, Pipe } from '@angular/core';
import * as i4 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i5 from 'ng-lazyload-image';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { addMilliseconds } from 'date-fns';
import { Subject, timer, interval, startWith, map, filter as filter$1, distinctUntilChanged, debounceTime, takeUntil as takeUntil$1 } from 'rxjs';
import { first, takeUntil, take, filter } from 'rxjs/operators';
import * as i1 from '@angular/platform-browser';
import * as i6 from 'ngx-skeleton-loader';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import * as i3 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i5$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, UntypedFormControl, ReactiveFormsModule, FormControl } from '@angular/forms';
import * as i4$1 from 'ngx-mask';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import * as i2 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i3$1 from '@angular/material/core';
import { MatNativeDateModule, _countGroupLabelsBeforeOption, _getOptionScrollPosition } from '@angular/material/core';
import * as i4$2 from 'ngx-mat-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import * as i1$2 from 'ngx-device-detector';
import * as i2$1 from 'ng-click-outside';
import { ClickOutsideModule } from 'ng-click-outside';
import { animation, style, animate, trigger, transition, useAnimation } from '@angular/animations';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1$3 from '@angular/cdk/overlay';
import * as i3$2 from 'ngx-autosize';
import { AutosizeModule } from 'ngx-autosize';
import * as i3$3 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i3$4 from '@angular/material/progress-bar';
import { MatProgressBar } from '@angular/material/progress-bar';
import * as i1$4 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i1$5 from '@le2xx/ngx-audio-player';
import { NgxAudioPlayerModule } from '@le2xx/ngx-audio-player';
const _c0 = () => ({
  height: "100%",
  "margin-bottom": "0",
  "border-radius": "50%"
});
const _c1 = () => ({
  height: "100%",
  "margin-bottom": "0",
  "border-radius": "10px"
});
function OnUiCoverComponent_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OnUiCoverComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtemplate(1, OnUiCoverComponent_ng_template_0_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const img_r2 = i0.ɵɵreference(4);
    i0.ɵɵstyleProp("aspect-ratio", ctx_r0.cover == null ? null : ctx_r0.cover.aspect);
    i0.ɵɵclassProp("base", (ctx_r0.cover == null ? null : ctx_r0.cover.form) === "base")("circle", (ctx_r0.cover == null ? null : ctx_r0.cover.form) === "circle")("with-blur", ctx_r0.withBlur);
    i0.ɵɵproperty("routerLink", ctx_r0.cover == null ? null : ctx_r0.cover.link)("title", ctx_r0.cover == null ? null : ctx_r0.cover.title);
    i0.ɵɵattribute("alt", ctx_r0.cover == null ? null : ctx_r0.cover.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", img_r2);
  }
}
function OnUiCoverComponent_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OnUiCoverComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, OnUiCoverComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const img_r2 = i0.ɵɵreference(4);
    i0.ɵɵstyleProp("aspect-ratio", ctx_r0.cover == null ? null : ctx_r0.cover.aspect);
    i0.ɵɵclassProp("base", (ctx_r0.cover == null ? null : ctx_r0.cover.form) === "base")("circle", (ctx_r0.cover == null ? null : ctx_r0.cover.form) === "circle")("with-blur", ctx_r0.withBlur);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", img_r2);
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("scale", ctx_r0.scale);
    i0.ɵɵproperty("lazyLoad", ctx_r0.cover == null ? null : ctx_r0.cover.img);
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_ng_template_2_ngx_skeleton_loader_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c0));
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_ng_template_2_ngx_skeleton_loader_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c1));
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_ng_template_2_ngx_skeleton_loader_0_Template, 1, 2, "ngx-skeleton-loader", 12)(1, OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_ng_template_2_ngx_skeleton_loader_1_Template, 1, 2, "ngx-skeleton-loader", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", (ctx_r0.cover == null ? null : ctx_r0.cover.form) === "circle");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.cover == null ? null : ctx_r0.cover.form) !== "circle");
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_div_0_Template, 1, 3, "div", 8);
    i0.ɵɵelementStart(1, "img", 9);
    i0.ɵɵlistener("load", function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_Template_img_load_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.onStateChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_ng_template_2_Template, 2, 2, "ng-template", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r0.withBlur);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("aspect-ratio", ctx_r0.cover == null ? null : ctx_r0.cover.aspect);
    i0.ɵɵclassProp("scale", ctx_r0.scale)("invisible", !ctx_r0.isLoaded);
    i0.ɵɵpropertyInterpolate("ngSrc", ctx_r0.cover == null ? null : ctx_r0.cover.img);
    i0.ɵɵproperty("alt", ctx_r0.cover == null ? null : ctx_r0.cover.title)("title", ctx_r0.cover == null ? null : ctx_r0.cover.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isLoaded);
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("scale", ctx_r0.scale);
    i0.ɵɵproperty("src", ctx_r0.cover == null ? null : ctx_r0.cover.img, i0.ɵɵsanitizeUrl)("alt", ctx_r0.cover == null ? null : ctx_r0.cover.title)("title", ctx_r0.cover == null ? null : ctx_r0.cover.title);
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_0_Template, 3, 11, "ng-template", 4)(1, OnUiCoverComponent_ng_template_3_ng_template_0_ng_template_1_Template, 1, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const server_r4 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isBrowser)("ngIfElse", server_r4);
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("scale", ctx_r0.scale);
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", ctx_r0.cover == null ? null : ctx_r0.cover.title)("title", ctx_r0.cover == null ? null : ctx_r0.cover.title);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.svgsetIconUrl("cover-placeholder"), null, "xlink");
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 18);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("scale", ctx_r0.scale);
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", ctx_r0.cover == null ? null : ctx_r0.cover.title)("title", ctx_r0.cover == null ? null : ctx_r0.cover.title);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r0.svgsetIconUrl("avatar-placeholder"), null, "xlink");
  }
}
function OnUiCoverComponent_ng_template_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiCoverComponent_ng_template_3_ng_template_1_ng_template_0_Template, 3, 5, "ng-template", 10)(1, OnUiCoverComponent_ng_template_3_ng_template_1_ng_template_1_Template, 3, 5, "ng-template", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.cover == null ? null : ctx_r0.cover.type) === "cover");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.cover == null ? null : ctx_r0.cover.type) === "avatar");
  }
}
function OnUiCoverComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiCoverComponent_ng_template_3_ng_template_0_Template, 3, 2, "ng-template", 4)(1, OnUiCoverComponent_ng_template_3_ng_template_1_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const noCover_r5 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.cover == null ? null : ctx_r0.cover.img)("ngIfElse", noCover_r5);
  }
}
function OnUiBulletListComponent_li_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r1));
  }
}
function OnUiRadioComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.radio == null ? null : ctx_r0.radio.text));
  }
}
const _c2 = ["*"];
function OnUiInputComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", (ctx_r0.value == null ? null : ctx_r0.value.length) || 0, " / ", ctx_r0.maxlength, "");
  }
}
function OnUiSelectComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.native"));
  }
}
function OnUiSelectComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.foreign"));
  }
}
function OnUiSelectComponent_mat_option_11_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.native"));
  }
}
function OnUiSelectComponent_mat_option_11_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.foreign"));
  }
}
function OnUiSelectComponent_mat_option_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 9)(1, "div", 3)(2, "span", 4);
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "span", 11);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, OnUiSelectComponent_mat_option_11_ng_template_7_Template, 3, 3, "ng-template", 5)(8, OnUiSelectComponent_mat_option_11_ng_template_8_Template, 3, 3, "ng-template", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("disabled", option_r1.disabled)("value", option_r1.value);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 6, option_r1.title), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(6, 8, option_r1.sub_title), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r1 == null ? null : option_r1.native);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r1 == null ? null : option_r1.foreign);
  }
}
function OnUiSelectSearchComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.native"));
  }
}
function OnUiSelectSearchComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.foreign"));
  }
}
function OnUiSelectSearchComponent_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function OnUiSelectSearchComponent_button_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearSearch());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 14);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIconUrl("close-sm"), null, "xlink");
  }
}
function OnUiSelectSearchComponent_mat_option_15_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.native"));
  }
}
function OnUiSelectSearchComponent_mat_option_15_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "subject-selector.foreign"));
  }
}
function OnUiSelectSearchComponent_mat_option_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15)(1, "div", 3)(2, "span", 4);
    i0.ɵɵelement(3, "span", 16);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "span", 17);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, OnUiSelectSearchComponent_mat_option_15_ng_template_7_Template, 3, 3, "ng-template", 5)(8, OnUiSelectSearchComponent_mat_option_15_ng_template_8_Template, 3, 3, "ng-template", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵproperty("disabled", option_r3.disabled)("value", option_r3.value);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 6, option_r3.title), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(6, 8, option_r3.sub_title), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", option_r3 == null ? null : option_r3.native);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", option_r3 == null ? null : option_r3.foreign);
  }
}
function OnUiSelectSearchComponent_p_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18)(1, "span");
    i0.ɵɵtext(2, "No entry matches");
    i0.ɵɵelementEnd()();
  }
}
const _c3 = "@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option.mat-active{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option.mat-mdc-option-disabled{color:#a4b0c3}.multi-select.mat-autocomplete-panel{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel .mat-mdc-option:hover,.multi-select.mat-autocomplete-panel .mat-mdc-option.mat-active{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel .mat-mdc-option.mat-mdc-option-disabled{color:#a4b0c3}.mat-datepicker-content{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.select{position:relative}.select .input{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;background:#fff;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;height:34px;line-height:30px;transition:border-color .2s linear}.select .input:hover{border-color:#a4b0c3}.select .icon{stroke:#a4b0c3;position:absolute;right:12px;top:14px;transform:rotate(180deg);transition:all .2s linear}.select.disabled .input{background:#f6f6f6;color:#ccc;border-color:#eee}.select.disabled .icon{stroke:#ccc}.select.disabled .mat-mdc-select-value{color:#ccc}.select.opened .input{border-color:#5ab3e4}.select.opened .icon{stroke:#5ab3e4;transform:rotate(0);transition:all .2s linear}.select.error .input{border:1px solid #E86F79}.select .mat-mdc-select-trigger{height:28px;padding:0 8px 0 10px;margin-top:3px}.select .mat-mdc-select-trigger .mat-mdc-select-arrow{opacity:0}.select .mat-mdc-select-placeholder{color:#6d7382;letter-spacing:normal}.select.transparent .mat-mdc-select{border:0;background:transparent}.select.transparent .mat-mdc-select .mat-mdc-select-trigger{padding:0;margin:0;height:34px}.mdc-list-item__primary-text{width:100%}.option-wrap{align-items:center;display:flex;justify-content:space-between}.option-wrap .option{overflow:hidden;text-overflow:ellipsis;letter-spacing:normal;margin-right:10px;line-height:normal;white-space:nowrap;display:block;width:100%}.option-wrap .option .sub_value{color:#a4b0c3;margin-left:4px}.option-wrap .native{color:#a4b0c3;font-size:14px;line-height:26px}.app-select-panel.mat-mdc-select-panel{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:-1px}.app-select-panel.mat-mdc-select-panel .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;min-height:30px;line-height:26px;cursor:pointer;padding:0 10px}.app-select-panel.mat-mdc-select-panel .mat-mdc-option .mat-mdc-option-pseudo-checkbox{display:none!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-active{background-color:#5ab3e4!important;color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-active.mdc-list-item{color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-active.mdc-list-item .option .sub_value{color:#e2e9f3}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-disabled{background-color:#a4b0c3!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-disabled .option .sub_value{color:#e2e9f3}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover{background-color:#5ab3e4!important;color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover.mdc-list-item{color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover.mdc-list-item .option .sub_value{color:#e2e9f3}.mat-mdc-option.hidden{display:none}\n";
function OnUiReceiptComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate5("", i0.ɵɵpipeBind1(2, 5, "payment-form.summary.text3"), " 1 ", i0.ɵɵpipeBind1(3, 7, "payment-form.summary.currency-code" + ctx_r0.fromCurrencyId), " ", i0.ɵɵpipeBind1(4, 9, "payment-form.summary.text4"), " ", ctx_r0.rate, " ", i0.ɵɵpipeBind1(5, 11, "payment-form.summary.currency-code" + ctx_r0.toCurrencyId), " ");
  }
}
function OnUiReceiptComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 9);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, item_r2 == null ? null : item_r2.title));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r2 == null ? null : item_r2.count);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r2 == null ? null : item_r2.total_amount == null ? null : item_r2.total_amount.formatFixed());
  }
}
const _c4 = ["button"];
function OnUiButtonComponent_div_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function OnUiButtonComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, OnUiButtonComponent_div_2_ng_template_1_Template, 2, 0, "ng-template", 7);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("after", ctx_r1.iconPosition === "after");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.iconPosition);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, ctx_r1.label));
  }
}
function OnUiButtonComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
}
function OnUiButtonComponent_ng_template_8_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OnUiButtonComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiButtonComponent_ng_template_8_ng_container_0_Template, 1, 0, "ng-container", 12);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const progress_r3 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", progress_r3);
  }
}
function OnUiButtonComponent_ng_template_9_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OnUiButtonComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiButtonComponent_ng_template_9_ng_container_0_Template, 1, 0, "ng-container", 12);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const done_r4 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", done_r4);
  }
}
function OnUiButtonComponent_ng_template_10_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function OnUiButtonComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiButtonComponent_ng_template_10_ng_container_0_Template, 1, 0, "ng-container", 12);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const fail_r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", fail_r5);
  }
}
function OnUiButtonComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "div", 14)(2, "div", 15)(3, "div", 16);
    i0.ɵɵelementEnd();
  }
}
function OnUiButtonComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 18);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("button-done"), null, "xlink");
  }
}
function OnUiButtonComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 18);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("button-fail"), null, "xlink");
  }
}
const _c5 = [[["title"]], [["content"]]];
const _c6 = ["title", "content"];
function OnUiCardMenuComponent_ng_template_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r1.title));
  }
}
function OnUiCardMenuComponent_ng_template_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 7);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.icon);
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r1.svgSetIcon(ctx_r1.icon), null, "xlink");
  }
}
function OnUiCardMenuComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, OnUiCardMenuComponent_ng_template_1_ng_template_0_Template, 3, 3, "ng-template", 5)(1, OnUiCardMenuComponent_ng_template_1_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const iconMenu_r3 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.title)("ngIfElse", iconMenu_r3);
  }
}
function OnUiPopoverComponent_ng_template_1_Template(rf, ctx) {}
function OnUiPopoverComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function OnUiPopoverComponent_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 4);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r1.svgsetIcon("close-sm"), null, "xlink");
  }
}
function OnUiTooltipComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@on-ui-tooltip", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function OnUiFormFieldErrorComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.error));
  }
}
const _c7 = (a0, a1) => ({
  "height": a0,
  "min-height": a1
});
function OnUiTabsComponent_li_2_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", tab_r2.count, ")");
  }
}
function OnUiTabsComponent_li_2__svg_svg_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8);
    i0.ɵɵelement(1, "use");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("href", ctx_r2.svgsetIcon(tab_r2.icon), null, "xlink");
  }
}
function OnUiTabsComponent_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3)(1, "a", 4)(2, "button", 5);
    i0.ɵɵlistener("click", function OnUiTabsComponent_li_2_Template_button_click_2_listener($event) {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.checkCondition($event, tab_r2));
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, OnUiTabsComponent_li_2_span_5_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, OnUiTabsComponent_li_2__svg_svg_6_Template, 2, 1, "svg", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r2.isActive(tab_r2));
    i0.ɵɵproperty("routerLink", tab_r2.route);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, tab_r2.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", tab_r2.count);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r2.icon);
  }
}
const _c8 = ["picker"];
function OnUiDateComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 4)(2, "input", 5);
    i0.ɵɵlistener("dateChange", function OnUiDateComponent_ng_container_1_Template_input_dateChange_2_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChanged($event));
    })("click", function OnUiDateComponent_ng_container_1_Template_input_click_2_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext();
      const picker_r4 = i0.ɵɵreference(4);
      return i0.ɵɵresetView(picker_r4.open());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 6);
    i0.ɵɵelement(4, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const picker_r4 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matDatepicker", picker_r4)("value", ctx_r2.inputValue)("min", ctx_r2.min)("max", ctx_r2.max)("placeholder", ctx_r2.placeholder);
    i0.ɵɵattribute("disabled", ctx_r2.isDisabled ? true : null);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("href", ctx_r2.svgsetIconUrl("chevron-up"), null, "xlink");
  }
}
function OnUiDateComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 4)(2, "input", 7);
    i0.ɵɵlistener("dateChange", function OnUiDateComponent_ng_container_2_Template_input_dateChange_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChanged($event));
    })("click", function OnUiDateComponent_ng_container_2_Template_input_click_2_listener() {
      i0.ɵɵrestoreView(_r5);
      i0.ɵɵnextContext();
      const picker_r4 = i0.ɵɵreference(4);
      return i0.ɵɵresetView(picker_r4.open());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const picker_r4 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matDatepicker", picker_r4)("value", ctx_r2.inputValue)("min", ctx_r2.min)("max", ctx_r2.max);
  }
}
function OnUiAutocompleteComponent_mat_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 7);
    i0.ɵɵelement(1, "span", 8);
    i0.ɵɵpipe(2, "highlight");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵnextContext();
    const search_r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("value", option_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, option_r2.title, search_r3.value), i0.ɵɵsanitizeHtml);
  }
}
const _c9 = ["audioPlayer"];
let OnUiSpriteComponent = /*#__PURE__*/(() => {
  class OnUiSpriteComponent {
    static {
      this.ɵfac = function OnUiSpriteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiSpriteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiSpriteComponent,
        selectors: [["on-ui-sprite"]],
        decls: 23,
        vars: 0,
        consts: [[1, "on-ui-sprite"], ["xmlns", "http://www.w3.org/2000/svg"], ["id", "on-ui-avatar-placeholder", "viewBox", "0 0 140 140", "fill", "none"], ["cx", "70", "cy", "70", "r", "70", "fill", "#FFFFFF"], ["d", "M70 0C31.402 0 0 31.402 0 70C0 108.598 31.402 140 70 140C108.598 140 140 108.598 140 70C140 31.402 108.598 0 70 0ZM70 134.4C50.05 134.4 32.1888 125.28 20.3672 110.989C22.5316 108.884 25.3064 106.294 28 103.6C31.7968 99.8032 48.4596 96.0092 56 93.9568V85.4056C55.6472 82.5384 53.1496 78.2572 50.9292 72.6628C47.474 71.6968 44.8 65.198 44.8 60.2C44.8 56.952 45.9424 55.1012 47.6784 54.124C44.8 33.6 56.6048 25.2 70 25.2C83.3952 25.2 95.2 33.6 92.3216 54.124C94.0576 55.1012 95.2 56.952 95.2 60.2C95.2 65.198 92.526 71.6968 89.0708 72.6656C86.8504 78.2572 84.3528 82.5384 84 85.4084V93.9596C91.5404 96.012 108.203 99.806 112 103.603C114.694 106.296 117.468 108.886 119.633 110.992C107.811 125.28 89.95 134.4 70 134.4Z", "fill", "#EFF1F6"], ["id", "on-ui-cover-placeholder", "viewBox", "0 0 25 25", "fill", "none"], ["d", "M23.0988 0.00134603L25 1.90352L22.309 4.59804V19.611C22.309 20.3245 22.0255 21.0088 21.5209 21.5134C21.0163 22.018 20.3318 22.3014 19.6181 22.3014H4.60281L1.90248 25L0 23.0979L23.0974 0L23.0988 0.00134603ZM12.1104 14.7949L13.456 16.1403L14.8014 14.7949C15.2106 14.4677 15.7256 14.3021 16.249 14.3293C16.7723 14.3566 17.2673 14.5749 17.6403 14.943L19.6181 16.9205V7.28853L12.1104 14.7949ZM15.7971 3.46803H3.47263V12.0506L6.41918 9.1046L8.28937 10.9745L0.781707 18.485V3.46803C0.781707 2.75448 1.06522 2.07014 1.56987 1.56558C2.0745 1.06101 2.75896 0.777553 3.47263 0.777553H18.4906L15.7997 3.46803H15.7971Z", "fill", "#FFFFFF"], ["id", "on-ui-chevron-up", "fill", "none", "viewBox", "0 0 12 7"], ["d", "M1 6L6 1L11 6", "stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round"], ["id", "on-ui-menu", "viewBox", "0 0 5 19", "stroke", "none"], ["cx", "2.5", "cy", "16.5", "r", "2.5", "transform", "rotate(180 2.5 16.5)"], ["cx", "2.5", "cy", "2.5", "r", "2.5", "transform", "rotate(180 2.5 2.5)"], ["cx", "2.5", "cy", "9.5", "r", "2.5", "transform", "rotate(180 2.5 9.5)"], ["id", "on-ui-close-sm", "viewBox", "0 0 12 12"], ["d", "M3 3L8.99993 8.99993", "stroke", "#A4B0C3", "stroke-width", "2", "stroke-linecap", "round"], ["d", "M9 3L3.00007 8.99993", "stroke", "#A4B0C3", "stroke-width", "2", "stroke-linecap", "round"], ["id", "on-ui-menu-circle", "viewBox", "0 0 24 24", "fill", "none"], ["d", "M12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64872 18.3513 0.499999 12 0.499999C5.64873 0.5 0.5 5.64873 0.500001 12C0.500001 18.3513 5.64873 23.5 12 23.5Z", "fill", "white", "stroke", "#EEEEEE"], ["d", "M7.59961 10.7998L11.9996 15.1998L16.3996 10.7998", "stroke", "#41A1D9", "stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round"], ["id", "on-ui-button-done", "viewBox", "0 0 24 24", "stroke", "none"], ["d", "M18.0002 7L16.5902 5.59L10.2502 11.93L11.6602 13.34L18.0002 7ZM22.2402 5.59L11.6602 16.17L7.48016 12L6.07016 13.41L11.6602 19L23.6602 7L22.2402 5.59ZM0.410156 13.41L6.00016 19L7.41016 17.59L1.83016 12L0.410156 13.41Z"], ["id", "on-ui-button-fail", "viewBox", "0 0 24 24", "stroke", "none"], ["d", "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"]],
        template: function OnUiSpriteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1)(2, "symbol", 2);
            i0.ɵɵelement(3, "circle", 3)(4, "path", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "symbol", 5);
            i0.ɵɵelement(6, "path", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "symbol", 7);
            i0.ɵɵelement(8, "path", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "symbol", 9);
            i0.ɵɵelement(10, "circle", 10)(11, "circle", 11)(12, "circle", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "symbol", 13);
            i0.ɵɵelement(14, "path", 14)(15, "path", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "symbol", 16);
            i0.ɵɵelement(17, "path", 17)(18, "path", 18);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "symbol", 19);
            i0.ɵɵelement(20, "path", 20);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "symbol", 21);
            i0.ɵɵelement(22, "path", 22);
            i0.ɵɵelementEnd()()();
          }
        },
        styles: [".on-ui-sprite[_ngcontent-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return OnUiSpriteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiSpriteModule = /*#__PURE__*/(() => {
  class OnUiSpriteModule {
    static {
      this.ɵfac = function OnUiSpriteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiSpriteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiSpriteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return OnUiSpriteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlatformService = /*#__PURE__*/(() => {
  class PlatformService {
    constructor(platformId) {
      this.platformId = platformId;
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.isServer = isPlatformServer(this.platformId);
    }
    static {
      this.ɵfac = function PlatformService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlatformService)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PlatformService,
        factory: PlatformService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PlatformService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// tslint:disable-next-line:directive-class-suffix
let DestroyableComponent = /*#__PURE__*/(() => {
  class DestroyableComponent {
    constructor(platform) {
      this.platform = platform;
      this.completable = [];
      this.destroyed$ = new Subject();
      if (platform) {
        this.isBrowser = platform.isBrowser;
        this.isServer = platform.isServer;
      }
    }
    ngOnDestroy() {
      this.destroyed$.next(true);
      this.destroyed$.complete();
      this.completable.map(s => s.complete());
      this.completable.splice(0);
    }
    register(instance) {
      this.completable.push(instance);
      return instance;
    }
    setTimeout(func, timeout) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      const dueTime = addMilliseconds(new Date(), timeout);
      if (this.isBrowser) {
        return timer(dueTime).pipe(first(), takeUntil(this.destroyed$)).subscribe(func);
      } else {
        func();
        return null;
      }
    }
    clearTimeout(timerLike) {
      if (!timerLike) {
        return;
      }
      if (typeof timerLike === 'number') {
        clearTimeout(timerLike);
      } else {
        if ('unsubscribe' in timerLike) {
          // instanceof Subscription
          timerLike.unsubscribe();
        }
      }
    }
    setInterval(func, period, count = 0) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      if (this.isBrowser) {
        let innerInterval = interval(period);
        if (count > 0) {
          innerInterval = innerInterval.pipe(take(count));
        }
        return innerInterval.pipe(takeUntil(this.destroyed$)).subscribe(func);
      } else {
        func();
        return null;
      }
    }
    clearInterval(intervalLike) {
      if (!intervalLike) {
        return;
      }
      if (typeof intervalLike === 'number') {
        clearInterval(intervalLike);
      } else {
        if ('unsubscribe' in intervalLike) {
          // instanceof Subscription
          intervalLike.unsubscribe();
        }
      }
    }
    onBrowserOnly(fn) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      if (this.isBrowser) {
        fn();
      }
    }
    onServerOnly(fn) {
      if (this.isBrowser === null || this.isBrowser === undefined) {
        throw new Error(`RuntimeError: 'platform' not injected in ${this.constructor.name}`);
      }
      if (this.isServer) {
        fn();
      }
    }
    static {
      this.ɵfac = function DestroyableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DestroyableComponent)(i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DestroyableComponent
      });
    }
  }
  return DestroyableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// tslint:disable-next-line:directive-class-suffix
let ChangableComponent = /*#__PURE__*/(() => {
  class ChangableComponent extends DestroyableComponent {
    constructor(cdr, platform) {
      super(platform);
      this.cdr = cdr;
      this.platform = platform;
    }
    detectChanges() {
      if (this.cdr && !this.cdr.destroyed) {
        this.cdr.detectChanges();
      }
    }
    markForCheck() {
      if (this.cdr && !this.cdr.destroyed) {
        this.cdr.markForCheck();
      }
    }
    static {
      this.ɵfac = function ChangableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ChangableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ChangableComponent,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return ChangableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconsService = /*#__PURE__*/(() => {
  class IconsService {
    static svgsetIconUrl(icon) {
      return `#on-ui-${icon}`;
    }
    static {
      this.ɵfac = function IconsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IconsService,
        factory: IconsService.ɵfac
      });
    }
  }
  return IconsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiCoverComponent = /*#__PURE__*/(() => {
  class OnUiCoverComponent extends ChangableComponent {
    set cover(cover) {
      this.innerCover = {
        ...cover,
        type: cover?.type || 'cover',
        title: cover?.title || ' ',
        form: cover?.form || 'base',
        aspect: cover?.aspect || '1/1'
      };
    }
    get cover() {
      return this.innerCover;
    }
    set scale(value) {
      this._scale = value;
      this.detectChanges();
    }
    get scale() {
      return this._scale;
    }
    onStateChange() {
      this.isLoaded = true;
      this.detectChanges();
    }
    constructor(_sanitizer, cdr, platform) {
      super(cdr, platform);
      this._sanitizer = _sanitizer;
      this.cdr = cdr;
      this.platform = platform;
      this.svgsetIconUrl = IconsService.svgsetIconUrl;
      this._scale = false;
      this.isLoaded = false;
    }
    defaultImage() {
      // TODO белый пиксель, для красивой загрузки
      const safeResourceUrl = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64, iVBORw0KGgoAAAANSUh' + 'EUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII=');
      return this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, safeResourceUrl);
    }
    static {
      this.ɵfac = function OnUiCoverComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiCoverComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiCoverComponent,
        selectors: [["on-ui-cover"]],
        inputs: {
          withBlur: "withBlur",
          cover: "cover",
          scale: "scale"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 2,
        consts: [["notLink", ""], ["img", ""], ["noCover", ""], ["server", ""], [3, "ngIf", "ngIfElse"], [1, "on-ui-cover", 3, "routerLink", "title"], [4, "ngTemplateOutlet"], [1, "on-ui-cover"], ["class", "background-with-blur", 3, "lazyLoad", "scale", 4, "ngIf"], ["fill", "", "loading", "eager", 1, "cover", 3, "load", "ngSrc", "alt", "title"], [3, "ngIf"], [1, "background-with-blur", 3, "lazyLoad"], ["class", "cover skeleton", 3, "theme", 4, "ngIf"], [1, "cover", "skeleton", 3, "theme"], [1, "cover", 3, "src", "alt", "title"], [1, "cover", "no-cover"], ["viewBox", "0 0 25 25", 1, "cover-placeholder"], [1, "cover"], ["viewBox", "0 0 140 140", 1, "avatar-placeholder"]],
        template: function OnUiCoverComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, OnUiCoverComponent_ng_template_0_Template, 2, 12, "ng-template", 4)(1, OnUiCoverComponent_ng_template_1_Template, 2, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, OnUiCoverComponent_ng_template_3_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const notLink_r6 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.cover == null ? null : ctx.cover.link)("ngIfElse", notLink_r6);
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i4.RouterLink, i5.LazyLoadImageDirective, i1$1.NgOptimizedImage, i6.NgxSkeletonLoaderComponent],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-cover[_ngcontent-%COMP%]{display:block;height:100%;width:100%;position:relative}.on-ui-cover[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{align-items:center;display:flex;height:100%;justify-content:center;object-fit:cover;object-position:center;width:100%;transition:all ease-in-out .5s;transform:none}.on-ui-cover[_ngcontent-%COMP%]   .cover.scale[_ngcontent-%COMP%]{transform:scale(1.1)}.on-ui-cover[_ngcontent-%COMP%]   .cover.no-cover[_ngcontent-%COMP%]{background:#eff1f6}.on-ui-cover[_ngcontent-%COMP%]   .cover.invisible[_ngcontent-%COMP%]{visibility:hidden}.on-ui-cover[_ngcontent-%COMP%]   .cover.skeleton[_ngcontent-%COMP%]{position:absolute;top:0}.on-ui-cover[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]   .cover-placeholder[_ngcontent-%COMP%]{max-height:40%;margin:30%;max-width:40%;height:100%;width:100%}.on-ui-cover[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]   .avatar-placeholder[_ngcontent-%COMP%]{height:100%;width:100%}.on-ui-cover.base[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{border-radius:10px}.on-ui-cover.circle[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{border-radius:50%}.on-ui-cover.with-blur[_ngcontent-%COMP%]{overflow:hidden}.on-ui-cover.with-blur[_ngcontent-%COMP%]   .background-with-blur[_ngcontent-%COMP%]{transition:all ease-in-out .5s;transform:none;position:absolute;width:100%;height:100%;background-position:center center;background-repeat:no-repeat;background-size:cover;filter:blur(5px)}.on-ui-cover.with-blur[_ngcontent-%COMP%]   .background-with-blur.scale[_ngcontent-%COMP%]{transform:scale(1.1)}.on-ui-cover.with-blur[_ngcontent-%COMP%]   .cover[_ngcontent-%COMP%]{object-fit:contain;position:absolute}.on-ui-cover.with-blur.base[_ngcontent-%COMP%]{border-radius:10px}.on-ui-cover.with-blur.circle[_ngcontent-%COMP%]{border-radius:50%}"],
        changeDetection: 0
      });
    }
  }
  return OnUiCoverComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiCoverModule = /*#__PURE__*/(() => {
  class OnUiCoverModule {
    static {
      this.ɵfac = function OnUiCoverModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiCoverModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiCoverModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, LazyLoadImageModule, NgxSkeletonLoaderModule]
      });
    }
  }
  return OnUiCoverModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiBulletListComponent = /*#__PURE__*/(() => {
  class OnUiBulletListComponent extends ChangableComponent {
    constructor(cdr, platform) {
      super(cdr, platform);
      this.cdr = cdr;
      this.platform = platform;
    }
    static {
      this.ɵfac = function OnUiBulletListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiBulletListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiBulletListComponent,
        selectors: [["on-ui-bullet-list"]],
        inputs: {
          bullet: "bullet"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 4,
        consts: [[1, "on-ui-bullet-list"], [1, "title"], [1, "list"], ["class", "list-item", 4, "ngFor", "ngForOf"], [1, "list-item"]],
        template: function OnUiBulletListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "ul", 2);
            i0.ɵɵtemplate(5, OnUiBulletListComponent_li_5_Template, 3, 3, "li", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx.bullet.title));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.bullet == null ? null : ctx.bullet.list);
          }
        },
        dependencies: [i1$1.NgForOf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-bullet-list[_ngcontent-%COMP%]{display:flex;flex-direction:column}.on-ui-bullet-list[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 0 10px;font-size:18px;line-height:24px}.on-ui-bullet-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]{margin:0;padding:0 0 0 27px}.on-ui-bullet-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 0 10px;color:#a4b0c3;font-size:14px;line-height:18px;color:#6d7381;position:relative;list-style-type:none}.on-ui-bullet-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%]:before{background:#5ab3e4;border-radius:50%;content:\"\";height:6px;margin:5px 0 0 -21px;position:absolute;width:6px}.on-ui-bullet-list[_ngcontent-%COMP%]   .list[_ngcontent-%COMP%]   .list-item[_ngcontent-%COMP%]:last-child{margin-bottom:0}"],
        changeDetection: 0
      });
    }
  }
  return OnUiBulletListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiBulletListModule = /*#__PURE__*/(() => {
  class OnUiBulletListModule {
    static {
      this.ɵfac = function OnUiBulletListModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiBulletListModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiBulletListModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiBulletListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiRadioComponent = /*#__PURE__*/(() => {
  class OnUiRadioComponent {
    constructor() {
      this.error = false;
      this.changed = new EventEmitter();
      this.propagateChange = () => {};
    }
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched() {}
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChanged(value) {
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
    }
    isChecked(value) {
      return this.value === value;
    }
    static {
      this.ɵfac = function OnUiRadioComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiRadioComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiRadioComponent,
        selectors: [["on-ui-radio"]],
        inputs: {
          radio: "radio",
          error: "error"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiRadioComponent),
          multi: true
        }])],
        decls: 9,
        vars: 9,
        consts: [[1, "on-ui-radio"], [1, "radio-wrap"], ["type", "radio", 1, "input", 3, "change", "value", "checked"], [1, "input-arrow"], [1, "label-block"], [1, "label"], [3, "ngIf"], [1, "text"]],
        template: function OnUiRadioComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1)(2, "input", 2);
            i0.ɵɵlistener("change", function OnUiRadioComponent_Template_input_change_2_listener() {
              return ctx.onChanged(ctx.radio.value);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "span", 3);
            i0.ɵɵelementStart(4, "div", 4)(5, "span", 5);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, OnUiRadioComponent_ng_template_8_Template, 3, 3, "ng-template", 6);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("error", ctx.error);
            i0.ɵɵproperty("value", ctx.radio.value)("checked", ctx.isChecked(ctx.radio.value));
            i0.ɵɵattribute("disabled", ctx.isDisabled || ctx.radio.disabled ? true : null);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 7, ctx.radio.label));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.radio == null ? null : ctx.radio.text);
          }
        },
        dependencies: [i1$1.NgIf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]{display:flex;transition:all .2s linear}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]:hover   .input-arrow[_ngcontent-%COMP%]{border-color:#a4b0c3}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{display:none}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:checked ~ .input-arrow[_ngcontent-%COMP%]{border-color:#5ab3e4}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:checked ~ .input-arrow[_ngcontent-%COMP%]:after{background:#5ab3e4}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled ~ .input-arrow[_ngcontent-%COMP%]{border-color:#ccc;cursor:default}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled ~ .label-block[_ngcontent-%COMP%]{cursor:default}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled ~ .label-block[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#ccc}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled:checked ~ .input-arrow[_ngcontent-%COMP%]{border-color:#ccc;cursor:default}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled:checked ~ .input-arrow[_ngcontent-%COMP%]:after{background:#ccc}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled:checked ~ .label-block[_ngcontent-%COMP%]{cursor:default}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled:checked ~ .label-block[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#ccc}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input.error[_ngcontent-%COMP%] ~ .input-arrow[_ngcontent-%COMP%]{border:2px solid #E86F79}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:checked.error ~ .input-arrow[_ngcontent-%COMP%]{border:2px solid #E86F79}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:checked.error ~ .input-arrow[_ngcontent-%COMP%]:after{background:#e86f79}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input-arrow[_ngcontent-%COMP%]{border:2px solid #EEEEEE;border-radius:50%;box-sizing:border-box;cursor:pointer;height:25px;margin-right:10px;position:relative;transition:all .2s linear;width:25px}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .input-arrow[_ngcontent-%COMP%]:after{background:transparent;border-radius:50%;content:\"\";position:absolute;height:11px;margin:5px;width:11px}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .label-block[_ngcontent-%COMP%]{cursor:pointer;display:flex;flex-direction:column;flex:1 1 10px}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .label-block[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:1px 0 4px;font-size:16px;line-height:24px}.on-ui-radio[_ngcontent-%COMP%]   .radio-wrap[_ngcontent-%COMP%]   .label-block[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px}"]
      });
    }
  }
  return OnUiRadioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiRadioModule = /*#__PURE__*/(() => {
  class OnUiRadioModule {
    static {
      this.ɵfac = function OnUiRadioModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiRadioModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiRadioModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiRadioModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiCheckboxComponent = /*#__PURE__*/(() => {
  class OnUiCheckboxComponent {
    constructor() {
      this.class = 'normal';
      this.changed = new EventEmitter();
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {}
    writeValue(value) {
      this.value = value;
      // logger.log('writeValue', this.value);
    }
    registerOnChange(fn) {
      // logger.log('registerOnChange', this.value);
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      // logger.log('registerOnTouched', this.value);
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChanged(value) {
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
    }
    onBlur() {
      this.propagateTouched();
    }
    static {
      this.ɵfac = function OnUiCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiCheckboxComponent,
        selectors: [["on-ui-checkbox"]],
        inputs: {
          class: "class"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiCheckboxComponent),
          multi: true
        }])],
        ngContentSelectors: _c2,
        decls: 5,
        vars: 3,
        consts: [[1, "checkbox", 3, "ngClass"], [1, "input-checkbox-wrap"], ["type", "checkbox", 1, "input-checkbox", 3, "change", "checked"], [1, "input-checkbox-item"]],
        template: function OnUiCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "label", 1)(2, "input", 2);
            i0.ɵɵlistener("change", function OnUiCheckboxComponent_Template_input_change_2_listener($event) {
              return ctx.onChanged($event.target.checked);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "span", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.class);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("checked", ctx.value);
            i0.ɵɵattribute("disabled", ctx.isDisabled ? true : null);
          }
        },
        dependencies: [i1$1.NgClass],
        styles: [".checkbox[_ngcontent-%COMP%]{display:block}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;cursor:pointer;-webkit-user-select:none;user-select:none;color:#1e252b}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .label-input-checkbox[_ngcontent-%COMP%]{color:#1e252b;font-size:16px;line-height:20px;margin-right:10px;transition:all .2s linear}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]{display:none}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:checked ~ .input-checkbox-item[_ngcontent-%COMP%]{border-color:#5ab3e4}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:checked ~ .input-checkbox-item[_ngcontent-%COMP%]:after{background:#5ab3e4}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:checked ~ .input-checkbox-item[_ngcontent-%COMP%]:hover:after{background:#41a1d9}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:checked ~ .label-input-checkbox[_ngcontent-%COMP%]{color:#1e252b}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:disabled ~ .input-checkbox-item[_ngcontent-%COMP%]{border-color:#eee}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:disabled ~ .label-input-checkbox[_ngcontent-%COMP%]{color:#eee;cursor:default}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:disabled:checked ~ .input-checkbox-item[_ngcontent-%COMP%]:after{background:#eee}.checkbox[_ngcontent-%COMP%]   .input-checkbox-wrap[_ngcontent-%COMP%]   .input-checkbox[_ngcontent-%COMP%]:disabled:checked ~ .input-checkbox-item[_ngcontent-%COMP%]:hover:after{background:#eee}.checkbox.normal[_ngcontent-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]{border:2px solid #cccccc;border-radius:5px;box-sizing:border-box;height:25px;margin-right:10px;position:relative;transition:all .2s linear;width:25px}.checkbox.normal[_ngcontent-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.checkbox.normal[_ngcontent-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]:after{background:transparent;border-radius:2px;content:\"\";position:absolute;height:13px;margin:4px;width:13px}.checkbox.small[_ngcontent-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]{border:1px solid #cccccc;border-radius:5px;box-sizing:border-box;height:16px;margin-right:10px;position:relative;transition:all .2s linear;width:16px}.checkbox.small[_ngcontent-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.checkbox.small[_ngcontent-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]:after{background:transparent;border-radius:2px;content:\"\";position:absolute;height:8px;margin:3px;width:8px}.field_error[_nghost-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%], .field_error   [_nghost-%COMP%]   .input-checkbox-item[_ngcontent-%COMP%]{border:2px solid red}"]
      });
    }
  }
  return OnUiCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiCheckboxModule = /*#__PURE__*/(() => {
  class OnUiCheckboxModule {
    static {
      this.ɵfac = function OnUiCheckboxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiCheckboxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiCheckboxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return OnUiCheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiInputComponent = /*#__PURE__*/(() => {
  class OnUiInputComponent extends ChangableComponent {
    /**
     * Маска для поля
     *
     * @See: https://github.com/JsDaddy/ngx-mask/blob/develop/USAGE.md
     * 0 - digits (like 0 to 9 numbers)
     * 9 - digits (like 0 to 9 numbers), but optional
     * A - letters (uppercase or lowercase) and digits
     * S - only letters (uppercase or lowercase)
     * U - only letters uppercase
     * L - only letters lowercase
     */
    set useMask(mask) {
      if (!mask) {
        return;
      }
      this.mask = mask;
      this.detectChanges();
    }
    get useMask() {
      return this.mask;
    }
    constructor(cdr, platform) {
      super(cdr, platform);
      this.cdr = cdr;
      this.platform = platform;
      this.error = false;
      /**
       * Вернуть вводимые данные с маской (если в маске есть разделители, тогда value тоже)
       * false = возвращать данные как в маске
       * true = возвращать данные как ввели
       */
      this.valueWithMask = false;
      this.changed = new EventEmitter();
      this.focusedChange = new EventEmitter();
      this.formControl = new UntypedFormControl();
      this.value = '';
      this.mask = null;
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {
      this.formControl.valueChanges.pipe(filter(value => value !== this.value), takeUntil(this.destroyed$)).subscribe(value => {
        this.value = value;
        this.propagateChange(value);
        this.changed.emit(value);
      });
    }
    writeValue(value) {
      this.value = value;
      this.formControl.setValue(value);
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onBlur() {
      this.propagateTouched();
      this.focusedChange.emit(false);
    }
    onFocus() {
      this.propagateTouched();
      this.focusedChange.emit(true);
    }
    static {
      this.ɵfac = function OnUiInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiInputComponent,
        selectors: [["on-ui-input"]],
        inputs: {
          placeholder: "placeholder",
          maxlength: "maxlength",
          hasCounter: "hasCounter",
          error: "error",
          useMask: "useMask",
          valueWithMask: "valueWithMask"
        },
        outputs: {
          changed: "changed",
          focusedChange: "focusedChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiInputComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 14,
        consts: [[1, "input-wrapper"], ["type", "text", 1, "input", 3, "blur", "focus", "formControl", "placeholder", "readonly", "mask", "dropSpecialCharacters"], ["class", "counter", 4, "ngIf"], [1, "counter"]],
        template: function OnUiInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
            i0.ɵɵlistener("blur", function OnUiInputComponent_Template_input_blur_1_listener() {
              return ctx.onBlur();
            })("focus", function OnUiInputComponent_Template_input_focus_1_listener() {
              return ctx.onFocus();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, OnUiInputComponent_div_2_Template, 2, 2, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.isDisabled)("error", ctx.error);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("input_counter", ctx.hasCounter);
            i0.ɵɵproperty("formControl", ctx.formControl)("placeholder", ctx.placeholder || "")("readonly", ctx.isDisabled)("mask", ctx.useMask)("dropSpecialCharacters", ctx.valueWithMask);
            i0.ɵɵattribute("maxlength", ctx.maxlength)("disabled", ctx.isDisabled ? true : null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hasCounter && ctx.maxlength);
          }
        },
        dependencies: [i1$1.NgIf, i5$1.DefaultValueAccessor, i5$1.NgControlStatus, i5$1.FormControlDirective, i4$1.NgxMaskDirective],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.input-wrapper[_ngcontent-%COMP%]{position:relative;background:#fff;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;height:34px;padding:0 10px;transition:all .2s linear;display:flex;flex-direction:row;justify-content:space-between;align-items:center}.input-wrapper[_ngcontent-%COMP%]:hover:not(.disabled){border-color:#a4b0c3}.input-wrapper[_ngcontent-%COMP%]:focus-within{border-color:#5ab3e4}.input-wrapper.disabled[_ngcontent-%COMP%]{background:#f6f6f6}.input-wrapper.disabled[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{color:#ccc;background:#f6f6f6}.input-wrapper.error[_ngcontent-%COMP%]{border:1px solid #E86F79}.input[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;appearance:none;outline:none;border:none;flex:1 1 1px;width:0;padding:0}.input[_ngcontent-%COMP%]::placeholder{color:#ccc;line-height:normal!important}.counter[_ngcontent-%COMP%]{font-size:12px;line-height:17px;color:#ccc;margin-left:10px}.field_error[_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%], .field_error   [_nghost-%COMP%]   .input-wrapper[_ngcontent-%COMP%]{border:1px solid #E86F79}"]
      });
    }
  }
  return OnUiInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiInputModule = /*#__PURE__*/(() => {
  class OnUiInputModule {
    static {
      this.ɵfac = function OnUiInputModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiInputModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiInputModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideNgxMask()],
        imports: [CommonModule, ReactiveFormsModule]
      });
    }
  }
  return OnUiInputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiSelectComponent = /*#__PURE__*/(() => {
  class OnUiSelectComponent {
    constructor() {
      this.autosize = false;
      this.class = 'normal';
      this.error = false;
      this.changed = new EventEmitter();
      this.svgsetIconUrl = IconsService.svgsetIconUrl;
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {}
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChanged(event) {
      const value = event.value ? event.value : null;
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
    }
    onBlur() {
      this.propagateTouched();
    }
    onOpened() {
      this.isOpened = true;
    }
    onClosed() {
      this.isOpened = false;
    }
    findOptionsByValue() {
      return this.options.find(o => o.value === this.value) || {
        value: null,
        title: ''
      };
    }
    static {
      this.ɵfac = function OnUiSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiSelectComponent,
        selectors: [["on-ui-select"]],
        inputs: {
          options: "options",
          placeholder: "placeholder",
          autosize: "autosize",
          class: "class",
          error: "error"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiSelectComponent),
          multi: true
        }])],
        ngContentSelectors: _c2,
        decls: 14,
        vars: 20,
        consts: [[1, "select", 3, "ngClass"], ["width", "12", "height", "7", 1, "icon"], ["disableOptionCentering", "", "panelClass", "app-select-panel", 1, "input", 3, "selectionChange", "blur", "closed", "opened", "value", "disabled", "panelWidth", "placeholder"], [1, "option-wrap"], [1, "option"], [3, "ngIf"], [3, "disabled", "value", 4, "ngFor", "ngForOf"], [1, "hidden"], [1, "native"], [3, "disabled", "value"], [1, "value", 3, "innerHTML"], [1, "sub_value", 3, "innerHTML"]],
        template: function OnUiSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵelement(2, "use");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(3, "mat-select", 2);
            i0.ɵɵlistener("selectionChange", function OnUiSelectComponent_Template_mat_select_selectionChange_3_listener($event) {
              return ctx.onChanged($event);
            })("blur", function OnUiSelectComponent_Template_mat_select_blur_3_listener() {
              return ctx.onBlur();
            })("closed", function OnUiSelectComponent_Template_mat_select_closed_3_listener() {
              return ctx.onClosed();
            })("opened", function OnUiSelectComponent_Template_mat_select_opened_3_listener() {
              return ctx.onOpened();
            });
            i0.ɵɵelementStart(4, "mat-select-trigger")(5, "div", 3)(6, "span", 4);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, OnUiSelectComponent_ng_template_9_Template, 3, 3, "ng-template", 5)(10, OnUiSelectComponent_ng_template_10_Template, 3, 3, "ng-template", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, OnUiSelectComponent_mat_option_11_Template, 9, 10, "mat-option", 6);
            i0.ɵɵelement(12, "mat-option", 7);
            i0.ɵɵprojection(13);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_11_0;
            let tmp_12_0;
            i0.ɵɵclassProp("disabled", ctx.isDisabled)("opened", ctx.isOpened)("error", ctx.error);
            i0.ɵɵproperty("ngClass", ctx.class);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", ctx.svgsetIconUrl("chevron-up"), null, "xlink");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("autosize", ctx.autosize);
            i0.ɵɵproperty("value", ctx.value)("disabled", ctx.isDisabled)("panelWidth", ctx.autosize ? null : "auto")("placeholder", ctx.placeholder);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 18, ctx.findOptionsByValue().title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (tmp_11_0 = ctx.findOptionsByValue()) == null ? null : tmp_11_0.native);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_12_0 = ctx.findOptionsByValue()) == null ? null : tmp_12_0.foreign);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.options);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i2.MatSelect, i2.MatSelectTrigger, i3$1.MatOption, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option.mat-active{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option.mat-mdc-option-disabled{color:#a4b0c3}.multi-select.mat-autocomplete-panel{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel .mat-mdc-option:hover,.multi-select.mat-autocomplete-panel .mat-mdc-option.mat-active{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel .mat-mdc-option.mat-mdc-option-disabled{color:#a4b0c3}.mat-datepicker-content{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.select{position:relative}.select .input{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;background:#fff;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;height:34px;line-height:30px;transition:border-color .2s linear}.select .input:hover{border-color:#a4b0c3}.select .icon{stroke:#a4b0c3;position:absolute;right:12px;top:14px;transform:rotate(180deg);transition:all .2s linear}.select.disabled .input{background:#f6f6f6;color:#ccc;border-color:#eee}.select.disabled .icon{stroke:#ccc}.select.disabled .mat-mdc-select-value{color:#ccc}.select.opened .input{border-color:#5ab3e4}.select.opened .icon{stroke:#5ab3e4;transform:rotate(0);transition:all .2s linear}.select.error .input{border:1px solid #E86F79}.select .mat-mdc-select-trigger{height:28px;padding:0 8px 0 10px;margin-top:3px}.select .mat-mdc-select-trigger .mat-mdc-select-arrow{opacity:0}.select .mat-mdc-select-placeholder{color:#6d7382;letter-spacing:normal}.select.transparent .mat-mdc-select{border:0;background:transparent}.select.transparent .mat-mdc-select .mat-mdc-select-trigger{padding:0;margin:0;height:34px}.mdc-list-item__primary-text{width:100%}.option-wrap{align-items:center;display:flex;justify-content:space-between}.option-wrap .option{overflow:hidden;text-overflow:ellipsis;letter-spacing:normal;margin-right:10px;line-height:normal;white-space:nowrap;display:block;width:100%}.option-wrap .option .sub_value{color:#a4b0c3;margin-left:4px}.option-wrap .native{color:#a4b0c3;font-size:14px;line-height:26px}.app-select-panel.mat-mdc-select-panel{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:-1px}.app-select-panel.mat-mdc-select-panel .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;min-height:30px;line-height:26px;cursor:pointer;padding:0 10px}.app-select-panel.mat-mdc-select-panel .mat-mdc-option .mat-mdc-option-pseudo-checkbox{display:none!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-active{background-color:#5ab3e4!important;color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-active.mdc-list-item{color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-active.mdc-list-item .option .sub_value{color:#e2e9f3}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-disabled{background-color:#a4b0c3!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option.mat-mdc-option-disabled .option .sub_value{color:#e2e9f3}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover{background-color:#5ab3e4!important;color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover.mdc-list-item{color:#fff!important}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover.mdc-list-item .option .sub_value{color:#e2e9f3}.mat-mdc-option.hidden{display:none}\n"],
        encapsulation: 2
      });
    }
  }
  return OnUiSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiSelectModule = /*#__PURE__*/(() => {
  class OnUiSelectModule {
    static {
      this.ɵfac = function OnUiSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, MatSelectModule]
      });
    }
  }
  return OnUiSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiSelectSearchComponent = /*#__PURE__*/(() => {
  class OnUiSelectSearchComponent {
    constructor() {
      this.autosize = false;
      this.class = 'normal';
      this.error = false;
      this.changed = new EventEmitter();
      this.searchCtrl = new FormControl();
      this.svgsetIconUrl = IconsService.svgsetIconUrl;
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
      this.filteredData$ = this.searchCtrl.valueChanges.pipe(startWith(''), map(searchKeyword => {
        if (!searchKeyword) {
          return this.options;
        }
        return this.options.filter(option => option.title.toLowerCase().indexOf(searchKeyword.toLowerCase()) > -1);
      }));
    }
    ngOnInit() {}
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChanged(event) {
      const value = event.value ? event.value : null;
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
    }
    onBlur() {
      this.propagateTouched();
    }
    onOpened() {
      this.isOpened = true;
    }
    onClosed() {
      this.isOpened = false;
    }
    clearSearch() {
      this.searchCtrl.setValue('');
    }
    findOptionsByValue() {
      return this.options.find(o => o.value === this.value) || {
        value: null,
        title: ''
      };
    }
    static {
      this.ɵfac = function OnUiSelectSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiSelectSearchComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiSelectSearchComponent,
        selectors: [["on-ui-select-search"]],
        inputs: {
          options: "options",
          placeholder: "placeholder",
          autosize: "autosize",
          class: "class",
          error: "error"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiSelectSearchComponent),
          multi: true
        }])],
        decls: 20,
        vars: 31,
        consts: [[1, "select", 3, "ngClass"], ["width", "12", "height", "7", 1, "icon"], ["disableOptionCentering", "", "panelClass", "app-select-panel", 1, "input", 3, "selectionChange", "blur", "closed", "opened", "value", "disabled", "panelWidth", "placeholder"], [1, "option-wrap"], [1, "option"], [3, "ngIf"], [1, "custom-search-item"], [3, "formControl", "hideClearSearchButton", "placeholderLabel"], ["mat-icon-button", "", "class", "custom-clear-btn", 3, "click", 4, "ngIf"], [3, "disabled", "value", 4, "ngFor", "ngForOf"], [1, "hidden"], ["class", "no-entries", 4, "ngIf"], [1, "native"], ["mat-icon-button", "", 1, "custom-clear-btn", 3, "click"], [1, "icon"], [3, "disabled", "value"], [1, "value", 3, "innerHTML"], [1, "sub_value", 3, "innerHTML"], [1, "no-entries"]],
        template: function OnUiSelectSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 1);
            i0.ɵɵelement(2, "use");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(3, "mat-select", 2);
            i0.ɵɵlistener("selectionChange", function OnUiSelectSearchComponent_Template_mat_select_selectionChange_3_listener($event) {
              return ctx.onChanged($event);
            })("blur", function OnUiSelectSearchComponent_Template_mat_select_blur_3_listener() {
              return ctx.onBlur();
            })("closed", function OnUiSelectSearchComponent_Template_mat_select_closed_3_listener() {
              return ctx.onClosed();
            })("opened", function OnUiSelectSearchComponent_Template_mat_select_opened_3_listener() {
              return ctx.onOpened();
            });
            i0.ɵɵelementStart(4, "mat-select-trigger")(5, "div", 3)(6, "span", 4);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, OnUiSelectSearchComponent_ng_template_9_Template, 3, 3, "ng-template", 5)(10, OnUiSelectSearchComponent_ng_template_10_Template, 3, 3, "ng-template", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "mat-option", 6);
            i0.ɵɵelement(12, "ngx-mat-select-search", 7);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵtemplate(14, OnUiSelectSearchComponent_button_14_Template, 3, 1, "button", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(15, OnUiSelectSearchComponent_mat_option_15_Template, 9, 10, "mat-option", 9);
            i0.ɵɵpipe(16, "async");
            i0.ɵɵelement(17, "mat-option", 10);
            i0.ɵɵtemplate(18, OnUiSelectSearchComponent_p_18_Template, 3, 0, "p", 11);
            i0.ɵɵpipe(19, "async");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_11_0;
            let tmp_12_0;
            i0.ɵɵclassProp("disabled", ctx.isDisabled)("opened", ctx.isOpened)("error", ctx.error);
            i0.ɵɵproperty("ngClass", ctx.class);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", ctx.svgsetIconUrl("chevron-up"), null, "xlink");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("autosize", ctx.autosize);
            i0.ɵɵproperty("value", ctx.value)("disabled", ctx.isDisabled)("panelWidth", ctx.autosize ? null : "auto")("placeholder", ctx.placeholder);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 23, ctx.findOptionsByValue().title));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (tmp_11_0 = ctx.findOptionsByValue()) == null ? null : tmp_11_0.native);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_12_0 = ctx.findOptionsByValue()) == null ? null : tmp_12_0.foreign);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formControl", ctx.searchCtrl)("hideClearSearchButton", true)("placeholderLabel", i0.ɵɵpipeBind1(13, 25, "content.search"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.searchCtrl.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(16, 27, ctx.filteredData$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(19, 29, ctx.filteredData$).length);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, i2.MatSelect, i2.MatSelectTrigger, i3$1.MatOption, i4$2.MatSelectSearchComponent, i5$1.NgControlStatus, i5$1.FormControlDirective, i1$1.AsyncPipe, i3.TranslatePipe],
        styles: [_c3, "@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option.mat-active{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel:not(.multi-select) .mat-mdc-option.mat-mdc-option-disabled{color:#a4b0c3}.multi-select.mat-autocomplete-panel{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel .mat-mdc-option{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel .mat-mdc-option:hover,.multi-select.mat-autocomplete-panel .mat-mdc-option.mat-active{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel .mat-mdc-option.mat-mdc-option-disabled{color:#a4b0c3}.mat-datepicker-content{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.custom-search-item{height:fit-content!important;margin-top:-10px!important;top:-10px!important}.custom-clear-btn{position:absolute;right:10px;top:15px;background:none;border:none;cursor:pointer;z-index:120}.custom-clear-btn .icon{width:20px;height:20px}.app-select-panel.mat-mdc-select-panel .mat-mdc-option{padding:0 15px}.app-select-panel.mat-mdc-select-panel .mat-mdc-option:hover.mdc-list-item.custom-search-item{color:initial!important}ngx-mat-select-search input{font-family:LatoWeb,sans-serif!important;padding:0 45px 0 15px!important}ngx-mat-select-search .mat-select-search-inner{margin-top:0}.no-entries{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;padding:15px;display:flex;flex-direction:column;justify-content:center}\n"],
        encapsulation: 2
      });
    }
  }
  return OnUiSelectSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiSelectSearchModule = /*#__PURE__*/(() => {
  class OnUiSelectSearchModule {
    static {
      this.ɵfac = function OnUiSelectSearchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiSelectSearchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiSelectSearchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, MatSelectModule, NgxMatSelectSearchModule, ReactiveFormsModule]
      });
    }
  }
  return OnUiSelectSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiReceiptComponent = /*#__PURE__*/(() => {
  class OnUiReceiptComponent {
    set exchange(exchange) {
      this.exchangeRate = exchange;
      this.recalcExchange();
    }
    constructor() {
      this.showExchange = false;
      this.fromCurrencyId = 1;
      this.toCurrencyId = 1;
    }
    ngOnInit() {
      this.recalcExchange();
    }
    recalcExchange() {
      if (this.exchangeRate) {
        this.showExchange = this.exchangeRate?.from_currency_id !== this.exchangeRate?.to_currency_id;
        this.toCurrencyId = this.exchangeRate?.to_currency_id;
        this.fromCurrencyId = this.exchangeRate?.from_currency_id;
        this.rate = this.exchangeRate?.rate.toFixed(3);
      }
      this.receipt.total.formatFixed();
      this.receipt.items[0].total_amount.formatFixed();
    }
    static {
      this.ɵfac = function OnUiReceiptComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiReceiptComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiReceiptComponent,
        selectors: [["on-ui-receipt"]],
        inputs: {
          receipt: "receipt",
          exchange: "exchange"
        },
        decls: 16,
        vars: 12,
        consts: [[1, "on-ui-receipt"], [1, "info"], [1, "info-text"], ["class", "info-text", 4, "ngIf"], ["class", "summary-item", 4, "ngFor", "ngForOf"], [1, "separator"], [1, "summary-item"], [1, "label"], [1, "value"], [1, "value", "right"]],
        template: function OnUiReceiptComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, OnUiReceiptComponent_span_6_Template, 6, 13, "span", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, OnUiReceiptComponent_div_7_Template, 8, 5, "div", 4);
            i0.ɵɵelement(8, "hr", 5);
            i0.ɵɵelementStart(9, "div", 6)(10, "span", 7);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "span", 8);
            i0.ɵɵelementStart(14, "span", 9);
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 6, "payment-form.summary.text2"), " ", i0.ɵɵpipeBind1(5, 8, "payment-form.summary.currency" + ctx.fromCurrencyId), "");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showExchange);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.receipt == null ? null : ctx.receipt.items);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 10, "payment-form.summary-item.label4"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.receipt == null ? null : ctx.receipt.total == null ? null : ctx.receipt.total.formatFixed());
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-receipt[_ngcontent-%COMP%]{border:1px solid #EEEEEE;border-radius:10px;padding:20px}.on-ui-receipt[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{background:#f5f8fa;border-radius:10px;display:flex;flex-direction:column;padding:20px;margin-bottom:20px}.on-ui-receipt[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]   .info-text[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b}.on-ui-receipt[_ngcontent-%COMP%]   .separator[_ngcontent-%COMP%]{background-color:#eee;border:none;height:1px;margin:18px 0 21px}.on-ui-receipt[_ngcontent-%COMP%]   .summary-item[_ngcontent-%COMP%]{display:flex}.on-ui-receipt[_ngcontent-%COMP%]   .summary-item[_ngcontent-%COMP%]:not(:last-child){margin-bottom:11px}.on-ui-receipt[_ngcontent-%COMP%]   .summary-item[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;width:184px}.on-ui-receipt[_ngcontent-%COMP%]   .summary-item[_ngcontent-%COMP%]   .value[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b;width:83px}.on-ui-receipt[_ngcontent-%COMP%]   .summary-item[_ngcontent-%COMP%]   .value.right[_ngcontent-%COMP%]{text-align:right}"],
        changeDetection: 0
      });
    }
  }
  return OnUiReceiptComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiReceiptModule = /*#__PURE__*/(() => {
  class OnUiReceiptModule {
    static {
      this.ɵfac = function OnUiReceiptModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiReceiptModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiReceiptModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiReceiptModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiButtonComponent = /*#__PURE__*/(() => {
  class OnUiButtonComponent extends ChangableComponent {
    set state(state) {
      this._state = state;
    }
    get state() {
      return this._state;
    }
    constructor(deviceService, cdr, platform) {
      super(cdr, platform);
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.platform = platform;
      this.class = 'primary';
      this.onclick = new EventEmitter();
      this.ripple = {
        enabled: false,
        top: 0,
        left: 0,
        width: 0
      };
      this.clickBlocked = false;
      this.svgsetIcon = IconsService.svgsetIconUrl;
      this._state = 'default';
      this._animationTime = 600;
    }
    ngOnInit() {}
    get isMobile() {
      return this.deviceService.isMobile();
    }
    onClick(event) {
      if (this.clickBlocked || this.disabled || this.state === 'progress') {
        return;
      }
      this.onclick.emit(event);
      this.clickBlocked = true;
      const btn = this.buttonRef.nativeElement;
      const diameter = btn.clientWidth;
      // logger.log(event.offsetY, diameter, event, this.buttonRef);
      this.ripple = {
        enabled: true,
        top: event.offsetY - diameter,
        left: event.offsetX - diameter,
        width: diameter * 2
      };
      this.setTimeout(() => {
        this.ripple.enabled = false;
        this.clickBlocked = false;
        this.markForCheck();
      }, this._animationTime);
      this.markForCheck();
    }
    static {
      this.ɵfac = function OnUiButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiButtonComponent)(i0.ɵɵdirectiveInject(i1$2.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiButtonComponent,
        selectors: [["on-ui-button"]],
        viewQuery: function OnUiButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonRef = _t.first);
          }
        },
        inputs: {
          label: "label",
          class: "class",
          disabled: "disabled",
          iconPosition: "iconPosition",
          state: "state"
        },
        outputs: {
          onclick: "onclick"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 18,
        vars: 27,
        consts: [["button", ""], ["progress", ""], ["done", ""], ["fail", ""], [1, "button", 3, "click", "ngClass", "disabled", "ngSwitch"], ["class", "label-wrap display", 3, "after", 4, "ngSwitchCase"], [1, "label-wrap", "hidden"], [3, "ngIf"], [1, "label"], [3, "ngSwitchCase"], [1, "label-wrap", "display"], [1, "side-icon-wrap"], [4, "ngTemplateOutlet"], [1, "progress"], [1, "spinner-item", "one"], [1, "spinner-item", "two"], [1, "spinner-item", "tree"], [1, "done"], ["width", "24", "height", "24", "viewBox", "0 0 24 24"]],
        template: function OnUiButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 4, 0);
            i0.ɵɵlistener("click", function OnUiButtonComponent_Template_button_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClick($event));
            });
            i0.ɵɵtemplate(2, OnUiButtonComponent_div_2_Template, 5, 6, "div", 5);
            i0.ɵɵelementStart(3, "div", 6);
            i0.ɵɵtemplate(4, OnUiButtonComponent_ng_template_4_Template, 1, 0, "ng-template", 7);
            i0.ɵɵelementStart(5, "span", 8);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, OnUiButtonComponent_ng_template_8_Template, 1, 1, "ng-template", 9)(9, OnUiButtonComponent_ng_template_9_Template, 1, 1, "ng-template", 9)(10, OnUiButtonComponent_ng_template_10_Template, 1, 1, "ng-template", 9);
            i0.ɵɵelement(11, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, OnUiButtonComponent_ng_template_12_Template, 4, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(14, OnUiButtonComponent_ng_template_14_Template, 3, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(16, OnUiButtonComponent_ng_template_16_Template, 3, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.disabled)("mobile", ctx.isMobile);
            i0.ɵɵproperty("ngClass", ctx.class)("disabled", ctx.disabled || ctx.class === "status")("ngSwitch", ctx.state);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitchCase", "default");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("after", ctx.iconPosition === "after");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.iconPosition);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 25, ctx.label));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngSwitchCase", "progress");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "done");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngSwitchCase", "fail");
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("top", ctx.ripple.top, "px")("left", ctx.ripple.left, "px")("width", ctx.ripple.width, "px")("height", ctx.ripple.width, "px");
            i0.ɵɵclassProp("ripple", ctx.ripple.enabled);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, i1$1.NgTemplateOutlet, i1$1.NgSwitch, i1$1.NgSwitchCase, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.button[_ngcontent-%COMP%]{background:transparent;border:1px solid transparent;border-radius:30px;cursor:pointer;height:40px;min-width:140px;padding:0 20px;position:relative;outline:none;overflow:hidden;transition:all .2s;-webkit-user-select:none;user-select:none}.button[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;pointer-events:none;justify-content:center}.button[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#fff;transition:all .2s;white-space:nowrap}.button[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .side-icon-wrap[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center;height:24px;margin-right:10px;width:24px}.button[_ngcontent-%COMP%]   .label-wrap.display[_ngcontent-%COMP%]{border-radius:30px;position:absolute;inset:0}.button[_ngcontent-%COMP%]   .label-wrap.hidden[_ngcontent-%COMP%]{visibility:hidden}.button[_ngcontent-%COMP%]   .label-wrap.after[_ngcontent-%COMP%]{flex-direction:row-reverse}.button[_ngcontent-%COMP%]   .label-wrap.after[_ngcontent-%COMP%]   .side-icon-wrap[_ngcontent-%COMP%]{margin:0 0 0 10px}.button[_ngcontent-%COMP%]   .ripple[_ngcontent-%COMP%]{position:absolute;border-radius:50%;transform:scale(0);animation:_ngcontent-%COMP%_ripple .6s linear;background-color:#ffffffb3;pointer-events:none}.button.primary[_ngcontent-%COMP%]{background:#5ab3e4;border:1px solid #5AB3E4}.button.primary[_ngcontent-%COMP%]:hover{border:1px solid #3491C3;background-color:#3491c3}.button.primary.outline[_ngcontent-%COMP%]{background:#fff}.button.primary.outline.transparent[_ngcontent-%COMP%]{background:transparent}.button.primary.outline[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#5ab3e4}.button.primary.outline[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:#5ab3e4}.button.primary.outline[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#5ab3e4}.button.primary.outline[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#3491c3}.button.poutline[_ngcontent-%COMP%]{border:1px solid #5AB3E4;background:#fff}.button.poutline[_ngcontent-%COMP%]:hover{border:1px solid #3491C3}.button.poutline.transparent[_ngcontent-%COMP%]{background:transparent}.button.poutline[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#5ab3e4}.button.poutline[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:#5ab3e4}.button.poutline[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#5ab3e4}.button.poutline[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#3491c3}.button.secondary[_ngcontent-%COMP%]{background:#87d37c;border:1px solid #87D37C}.button.secondary[_ngcontent-%COMP%]:hover{border:1px solid #65C558;background-color:#65c558}.button.secondary.outline[_ngcontent-%COMP%]{background:#fff}.button.secondary.outline[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#87d37c}.button.secondary.outline[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:#87d37c}.button.secondary.outline[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#87d37c}.button.secondary.outline[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#65c558}.button.danger[_ngcontent-%COMP%]{background:#e86f79;border:1px solid #E86F79}.button.danger[_ngcontent-%COMP%]:hover{border:1px solid #C84550;background-color:#c84550}.button.danger.outline[_ngcontent-%COMP%]{background:#fff}.button.danger.outline[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#e86f79}.button.danger.outline[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:#e86f79}.button.danger.outline[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#e86f79}.button.danger.outline[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#c84550}.button.danger.link[_ngcontent-%COMP%]{background:transparent;border:1px solid transparent}.button.danger.link[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#e86f79}.button.danger.link[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:#e86f79}.button.danger.link[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#e86f79}.button.danger.link[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#c84550}.button.third[_ngcontent-%COMP%]{background:#feed7d;border:1px solid #FEED7D}.button.third[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b}.button.third[_ngcontent-%COMP%]:hover{border:1px solid #FFDD00;background-color:#fd0}.button.transparent[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#41a1d9;text-decoration:underline transparent;transition:all .2s linear}.button.transparent[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#3491c3;text-decoration:underline #3491C3}.button.status[_ngcontent-%COMP%]{border:1px solid #EEEEEE;background-color:#eee}.button.status[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#a4b0c3}.button.white[_ngcontent-%COMP%]{background:#fff;border:1px solid #FFFFFF}.button.white[_ngcontent-%COMP%]:hover{border:1px solid #F5F8FA;background-color:#f5f8fa}.button.white[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b}.button.white.outline[_ngcontent-%COMP%]{background:transparent}.button.white.outline[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#fff}.button.white.outline[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:transparent}.button.white.outline[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}.button.white.outline[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#f5f8fa}.button.white.link[_ngcontent-%COMP%]{background:transparent;border:1px solid transparent}.button.white.link[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#fff}.button.white.link[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:transparent}.button.white.link[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}.button.white.link[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#f5f8fa}.button.grey[_ngcontent-%COMP%]{background:#a4b0c3;border:1px solid #A4B0C3}.button.grey[_ngcontent-%COMP%]:hover{border:1px solid #CCCCCC;background-color:#ccc}.button.grey.outline[_ngcontent-%COMP%]{background:transparent}.button.grey.outline[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#a4b0c3}.button.grey.outline[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:transparent}.button.grey.outline[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#a4b0c3}.button.grey.outline[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#ccc}.button.grey.link[_ngcontent-%COMP%]{background:transparent;border:1px solid transparent}.button.grey.link[_ngcontent-%COMP%]   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#a4b0c3}.button.grey.link[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:transparent}.button.grey.link[_ngcontent-%COMP%]   .done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#a4b0c3}.button.grey.link[_ngcontent-%COMP%]:hover   .label-wrap[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#ccc}.button.disabled[_ngcontent-%COMP%]{cursor:unset;opacity:.3}.button.disabled.third[_ngcontent-%COMP%]{opacity:.5}.button.mobile[_ngcontent-%COMP%]{height:36px}.progress[_ngcontent-%COMP%]{border-radius:30px;position:absolute;inset:0;align-items:center;display:flex;justify-content:center;pointer-events:none}.progress[_ngcontent-%COMP%]   .spinner-item[_ngcontent-%COMP%]{background:#fff;border-radius:50%;margin:0 3px;height:8px;width:8px}.progress[_ngcontent-%COMP%]   .spinner-item.one[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_circle-scale 1.5s .33s ease-in-out infinite}.progress[_ngcontent-%COMP%]   .spinner-item.two[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_circle-scale 1.5s .66s ease-in-out infinite}.progress[_ngcontent-%COMP%]   .spinner-item.tree[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_circle-scale 1.5s .99s ease-in-out infinite}.done[_ngcontent-%COMP%]{border-radius:30px;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;animation:_ngcontent-%COMP%_translateY .3s ease-in-out}.done[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}.fail[_ngcontent-%COMP%]{border-radius:30px;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;animation:_ngcontent-%COMP%_translateY .3s ease-in-out}.fail[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}@keyframes _ngcontent-%COMP%_translateY{0%{transform:translateY(10px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes _ngcontent-%COMP%_ripple{to{transform:scale(4);opacity:0}}@keyframes _ngcontent-%COMP%_circle-scale{50%{transform:scale(.5);opacity:.6}}"],
        changeDetection: 0
      });
    }
  }
  return OnUiButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiButtonModule = /*#__PURE__*/(() => {
  class OnUiButtonModule {
    static {
      this.ɵfac = function OnUiButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiFormStepComponent = /*#__PURE__*/(() => {
  class OnUiFormStepComponent extends ChangableComponent {
    constructor(cdr) {
      super(cdr);
      this.cdr = cdr;
      this.state = 'init';
      this.labelType = '';
    }
    static {
      this.ɵfac = function OnUiFormStepComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiFormStepComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiFormStepComponent,
        selectors: [["on-ui-form-step"]],
        inputs: {
          stepProps: "stepProps",
          state: "state",
          labelType: "labelType"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c6,
        decls: 13,
        vars: 11,
        consts: [[1, "form-step"], [1, "title-block"], [1, "step"], [1, "content-block"], [1, "left"], [1, "strip"], [1, "content"]],
        template: function OnUiFormStepComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 3)(9, "div", 4);
            i0.ɵɵelement(10, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 6);
            i0.ɵɵprojection(12, 1);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("success", ctx.state === "success")("error", ctx.state === "error");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.stepProps.count);
            i0.ɵɵadvance();
            i0.ɵɵclassMapInterpolate1("label ", ctx.labelType, "");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 9, ctx.stepProps.label));
          }
        },
        dependencies: [i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.form-step[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin-bottom:10px}.form-step[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]{align-items:center;display:flex}.form-step[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0 10px 0 0;font-size:14px;line-height:18px;align-items:center;border:1px solid #EEEEEE;background:#fff;border-radius:50%;box-sizing:border-box;color:#a4b0c3;display:flex;height:28px;justify-content:center;transition:all .2s;width:28px;flex-shrink:0}.form-step[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWebBold,sans-serif;font-weight:inherit;margin:0 10px 0 0;font-size:18px;line-height:24px}.form-step[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .label.text[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px}.form-step[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]{display:flex}.form-step[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:none;margin-right:10px;width:28px}.form-step[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .strip[_ngcontent-%COMP%]{background:#eee;width:1px;margin:5px 14px -5px;transition:all .2s;height:100%}.form-step[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex:1 1 10px;width:0}.form-step.success[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{background:#87d37c;border:1px solid #87D37C;color:#fff}.form-step.success[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .strip[_ngcontent-%COMP%]{background:#87d37c}.form-step.error[_ngcontent-%COMP%]   .title-block[_ngcontent-%COMP%]   .step[_ngcontent-%COMP%]{background:#e86f79;border:1px solid #E86F79;color:#fff}.form-step.error[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .strip[_ngcontent-%COMP%]{background:#e86f79}@media all and (min-width: 950px){.form-step[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]{display:block}}"],
        changeDetection: 0
      });
    }
  }
  return OnUiFormStepComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiFormStepModule = /*#__PURE__*/(() => {
  class OnUiFormStepModule {
    static {
      this.ɵfac = function OnUiFormStepModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiFormStepModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiFormStepModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiFormStepModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiButtonTabComponent = /*#__PURE__*/(() => {
  class OnUiButtonTabComponent extends ChangableComponent {
    constructor(cdr) {
      super(cdr);
      this.cdr = cdr;
      this.error = false;
      this.changed = new EventEmitter();
      this.propagateChange = () => {};
    }
    writeValue(value) {
      this.value = value;
      this.cdr.detectChanges();
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
      this.cdr.detectChanges();
    }
    registerOnTouched() {}
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
      this.cdr.detectChanges();
    }
    onChanged(value) {
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function OnUiButtonTabComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiButtonTabComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiButtonTabComponent,
        selectors: [["on-ui-button-tab"]],
        inputs: {
          buttonTab: "buttonTab",
          error: "error"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiButtonTabComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 7,
        consts: [[1, "on-ui-button-tab"], ["type", "checkbox", 1, "input", 3, "change", "checked"], [1, "label"]],
        template: function OnUiButtonTabComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
            i0.ɵɵlistener("change", function OnUiButtonTabComponent_Template_input_change_1_listener($event) {
              return ctx.onChanged($event.target.checked);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassProp("error", ctx.error);
            i0.ɵɵproperty("checked", ctx.value);
            i0.ɵɵattribute("disabled", ctx.isDisabled || (ctx.buttonTab == null ? null : ctx.buttonTab.disabled) ? true : null);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, ctx.buttonTab == null ? null : ctx.buttonTab.label));
          }
        },
        dependencies: [i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-button-tab[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{display:none}.on-ui-button-tab[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:checked ~ .label[_ngcontent-%COMP%]{background:#f6f6f6;border:1px solid #41A1D9}.on-ui-button-tab[_ngcontent-%COMP%]   .input.error[_ngcontent-%COMP%] ~ .label[_ngcontent-%COMP%]{border:1px solid #E86F79;color:#e86f79}.on-ui-button-tab[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#41a1d9;display:flex;align-items:center;background:#f5f8fa;border:1px solid transparent;border-radius:10px;box-sizing:border-box;cursor:pointer;height:32px;padding:0 10px;transition:all .2s}.on-ui-button-tab[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]:hover{background:#f5f8fa;border:1px solid #A4B0C3}"],
        changeDetection: 0
      });
    }
  }
  return OnUiButtonTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiButtonTabModule = /*#__PURE__*/(() => {
  class OnUiButtonTabModule {
    static {
      this.ɵfac = function OnUiButtonTabModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiButtonTabModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiButtonTabModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiButtonTabModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiCardMenuComponent = /*#__PURE__*/(() => {
  class OnUiCardMenuComponent {
    constructor() {
      this.icon = 'menu';
      this.svgSetIcon = IconsService.svgsetIconUrl;
      this.menuPopoverOpen = false;
    }
    toggleMenuPopover() {
      this.menuPopoverOpen = !this.menuPopoverOpen;
    }
    closeMenuPopover() {
      this.menuPopoverOpen = false;
    }
    static {
      this.ɵfac = function OnUiCardMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiCardMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiCardMenuComponent,
        selectors: [["on-ui-card-menu"]],
        inputs: {
          item: "item",
          title: "title",
          icon: "icon"
        },
        ngContentSelectors: _c2,
        decls: 5,
        vars: 7,
        consts: [["ref", ""], ["iconMenu", ""], [1, "card-menu", 3, "click", "clickOutside"], [3, "ngIf"], [1, "menu-popover"], [3, "ngIf", "ngIfElse"], [1, "opener"], [1, "opener", 3, "ngClass"]],
        template: function OnUiCardMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵlistener("click", function OnUiCardMenuComponent_Template_div_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleMenuPopover());
            })("clickOutside", function OnUiCardMenuComponent_Template_div_clickOutside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closeMenuPopover());
            });
            i0.ɵɵtemplate(1, OnUiCardMenuComponent_ng_template_1_Template, 3, 2, "ng-template", 3);
            i0.ɵɵelementStart(2, "div", 4, 0);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const ref_r4 = i0.ɵɵreference(3);
            i0.ɵɵclassProp("active", ctx.menuPopoverOpen)("icon-menu", !ctx.title);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ref_r4.querySelectorAll("*").length > 0);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("visible", ctx.menuPopoverOpen);
          }
        },
        dependencies: [i1$1.NgClass, i1$1.NgIf, i2$1.ClickOutsideDirective, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.card-menu[_ngcontent-%COMP%]{cursor:pointer;position:relative}.card-menu.icon-menu[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:center;height:32px;width:32px;border-radius:10px;transition:all .2s ease-in-out}.card-menu.icon-menu[_ngcontent-%COMP%]:hover, .card-menu.icon-menu.active[_ngcontent-%COMP%]{background-color:#f6f6f6;box-shadow:0 2px 4px #7c7c7c40}span.opener[_ngcontent-%COMP%]{color:#5ab3e4;white-space:nowrap}svg.opener.menu[_ngcontent-%COMP%]{width:5px;height:19px;fill:#5ab3e4}svg.opener.menu-circle[_ngcontent-%COMP%]{width:24px;height:24px;fill:transparent}.menu-popover[_ngcontent-%COMP%]{position:absolute;top:40px;right:-6px;display:none;background:#fff;box-shadow:0 0 10px #0000001a;padding:10px 0;border-radius:10px;color:#1e252b;z-index:20}.menu-popover[_ngcontent-%COMP%]:after{content:\"\";display:block;width:15px;height:15px;background:#fff;position:absolute;top:-8px;right:14px;transform:rotate(45deg);box-shadow:-11px -9px 9px #0000000d;z-index:0}.menu-popover.visible[_ngcontent-%COMP%]{display:block}.menu-popover[_ngcontent-%COMP%]     .menu-item{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;align-items:center;display:flex;height:26px;padding:0 10px;white-space:nowrap;color:inherit;text-decoration:none}.menu-popover[_ngcontent-%COMP%]     .menu-item.warn{background:#e86f79}.menu-popover[_ngcontent-%COMP%]     .menu-item a{color:inherit;text-decoration:none;display:block}.menu-popover[_ngcontent-%COMP%]     .menu-item button{width:100%;height:26px}.menu-popover[_ngcontent-%COMP%]     .menu-item:hover, .menu-popover[_ngcontent-%COMP%]     .menu-item:active, .menu-popover[_ngcontent-%COMP%]     .menu-item:focus{background:#5ab3e4;color:#fff}.menu-popover[_ngcontent-%COMP%]     .menu-item.danger{color:#e86f79}.menu-popover[_ngcontent-%COMP%]   .menu-item-icon[_ngcontent-%COMP%]{width:40px;height:40px;border-radius:40px;border:1px solid #EEEEEE;margin-right:15px;display:flex;align-items:center;justify-content:center;color:#6d7381;transition:background .2s linear,border-color .2s linear}.menu-popover[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{white-space:nowrap;display:flex;align-items:center;align-content:center;cursor:pointer;text-decoration:none;color:inherit}.menu-popover[_ngcontent-%COMP%]   a[disabled][_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed}.menu-popover[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{white-space:nowrap;display:flex;align-items:center;align-content:center;cursor:pointer}.menu-popover[_ngcontent-%COMP%]   button[disabled][_ngcontent-%COMP%]{opacity:.3;cursor:not-allowed}.menu-popover[_ngcontent-%COMP%]   .warning[_ngcontent-%COMP%]{color:#e86f79;padding-left:.5em}"],
        changeDetection: 0
      });
    }
  }
  return OnUiCardMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiCardMenuModule = /*#__PURE__*/(() => {
  class OnUiCardMenuModule {
    static {
      this.ɵfac = function OnUiCardMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiCardMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiCardMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, ClickOutsideModule]
      });
    }
  }
  return OnUiCardMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const moveFadeIn = animation([style({
  opacity: '0',
  transform: 'translateY({{slide}})'
}), animate('{{time}}', style({
  opacity: '1',
  transform: '*'
}))], {
  params: {
    time: '200ms',
    slide: '5px'
  }
});
const moveFadeOut = animation([style({
  opacity: '*'
}), animate('{{time}}', style({
  opacity: '0',
  transform: 'translateY({{slide}})'
}))], {
  params: {
    time: '200ms',
    slide: '5px'
  }
});
const fadeIn = animation([style({
  opacity: '0'
}), animate('{{time}}', style({
  opacity: '1'
}))], {
  params: {
    time: '200ms',
    slide: '5px'
  }
});
const fadeOut = animation([style({
  opacity: '*'
}), animate('{{time}}', style({
  opacity: '0'
}))], {
  params: {
    time: '200ms'
  }
});
const slideIn = animation([style({
  transform: 'translateX({{slide}})'
}), animate('{{time}}', style({
  transform: 'translateY(0)'
}))], {
  params: {
    time: '200ms',
    slide: '100vw'
  }
});
const slideOut = animation([style({
  transform: 'translateX(0)'
}), animate('{{time}}', style({
  transform: 'translateX({{slide}})'
}))], {
  params: {
    time: '200ms',
    slide: '100vw'
  }
});
const slideDown = animation([style({
  height: '0',
  opacity: '0'
}), animate('{{time}}', style({
  height: '*',
  opacity: '1'
}))], {
  params: {
    time: '200ms'
  }
});
const slideUp = animation([style({
  height: '*',
  opacity: '1'
}), animate('{{time}}', style({
  height: '0',
  opacity: '0'
}))], {
  params: {
    time: '200ms'
  }
});
let OnUiPopoverComponent = /*#__PURE__*/(() => {
  class OnUiPopoverComponent extends DestroyableComponent {
    constructor(platform) {
      super(platform);
      this.platform = platform;
      this.popoverOnly = false;
      // TODO: use native cdk click outside
      this.clickOutsideEnabled = false;
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    ngOnInit() {
      this.onBrowserOnly(() => {
        this.setTimeout(() => {
          this.clickOutsideEnabled = true;
        }, 250);
      });
    }
    close() {
      this.callback();
    }
    onOutsideClick() {
      this.callback();
    }
    static {
      this.ɵfac = function OnUiPopoverComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiPopoverComponent)(i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiPopoverComponent,
        selectors: [["on-ui-popover"]],
        inputs: {
          content: "content",
          callback: "callback",
          position: "position",
          showCloseButton: "showCloseButton",
          popoverOnly: "popoverOnly",
          styles: "styles"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 7,
        consts: [[1, "popover", 3, "clickOutside", "ngStyle", "clickOutsideEnabled"], [3, "ngTemplateOutlet"], ["class", "popover__close", 3, "click", 4, "ngIf"], [1, "popover__close", 3, "click"], [1, "icon"]],
        template: function OnUiPopoverComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("clickOutside", function OnUiPopoverComponent_Template_div_clickOutside_0_listener() {
              return ctx.onOutsideClick();
            });
            i0.ɵɵtemplate(1, OnUiPopoverComponent_ng_template_1_Template, 0, 0, "ng-template", 1)(2, OnUiPopoverComponent_div_2_Template, 3, 1, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("popover_only", ctx.popoverOnly);
            i0.ɵɵproperty("ngStyle", ctx.styles)("@popover", undefined)("clickOutsideEnabled", ctx.clickOutsideEnabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.content);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showCloseButton);
          }
        },
        dependencies: [i1$1.NgIf, i1$1.NgTemplateOutlet, i1$1.NgStyle, i2$1.ClickOutsideDirective],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.popover[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px #0000001a;border-radius:10px;padding:20px;position:relative}.popover__header[_ngcontent-%COMP%]{font-style:normal;font-family:LatoWebBold,sans-serif;font-weight:700;font-size:18px}.popover__close[_ngcontent-%COMP%]{width:24px;height:24px;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;transition:all .3s ease;border:1px solid #EEEEEE;box-sizing:border-box;position:absolute;right:15px;top:15px;display:none;background:#fff}.popover[_ngcontent-%COMP%]:hover   .popover__close[_ngcontent-%COMP%]{display:flex}.popover_only[_ngcontent-%COMP%]{padding:0}.popover_only[_ngcontent-%COMP%]:hover   .popover__close[_ngcontent-%COMP%]{display:none}.icon[_ngcontent-%COMP%]{fill:#a4b0c3;width:12px;height:12px}"],
        data: {
          animation: [trigger('popover', [transition(':enter', useAnimation(moveFadeIn, {
            params: {
              time: '150ms',
              slide: '5px'
            }
          })), transition(':leave', useAnimation(moveFadeOut))])]
        }
      });
    }
  }
  return OnUiPopoverComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var PopoverPositionEnum = /*#__PURE__*/function (PopoverPositionEnum) {
  PopoverPositionEnum["bottom"] = "bottom";
  PopoverPositionEnum["bottom_left"] = "bottom-left";
  PopoverPositionEnum["bottom_right"] = "bottom-right";
  PopoverPositionEnum["top"] = "top";
  PopoverPositionEnum["top_left"] = "top-left";
  PopoverPositionEnum["top_right"] = "top-right";
  PopoverPositionEnum["left"] = "left";
  PopoverPositionEnum["left_bottom"] = "left-bottom";
  PopoverPositionEnum["left_top"] = "left-top";
  PopoverPositionEnum["right"] = "right";
  PopoverPositionEnum["right_bottom"] = "right-bottom";
  PopoverPositionEnum["right_top"] = "right-top";
  return PopoverPositionEnum;
}(PopoverPositionEnum || {});
const OFFSET = 8;
const POSITIONS = {
  [PopoverPositionEnum.top]: {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    offsetY: -OFFSET
  },
  [PopoverPositionEnum.top_left]: {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetY: -OFFSET
  },
  [PopoverPositionEnum.top_right]: {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
    offsetY: -OFFSET
  },
  [PopoverPositionEnum.bottom]: {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: OFFSET,
    panelClass: 'pointer'
  },
  [PopoverPositionEnum.bottom_left]: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetY: OFFSET
  },
  [PopoverPositionEnum.bottom_right]: {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetY: OFFSET
  },
  [PopoverPositionEnum.left]: {
    originX: 'start',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
    offsetX: -OFFSET
  },
  [PopoverPositionEnum.left_top]: {
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
    offsetX: -OFFSET
  },
  [PopoverPositionEnum.left_bottom]: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetX: -OFFSET
  },
  [PopoverPositionEnum.right]: {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
    offsetX: OFFSET
  },
  [PopoverPositionEnum.right_top]: {
    originX: 'end',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetX: OFFSET
  },
  [PopoverPositionEnum.right_bottom]: {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetX: OFFSET
  }
};
const DEFAULT_POSITIONS_PRIORITY = [PopoverPositionEnum.bottom, PopoverPositionEnum.top];
const generatePositions = position => {
  let positionsPriority = [...DEFAULT_POSITIONS_PRIORITY];
  const index = positionsPriority.indexOf(position);
  if (index !== -1) {
    positionsPriority.splice(index, 1);
  }
  const priorPosition = POSITIONS[position];
  if (priorPosition) {
    positionsPriority = [position, ...positionsPriority];
  }
  return positionsPriority.map(key => POSITIONS[key]);
};
let OnUiPopoverDirective = /*#__PURE__*/(() => {
  class OnUiPopoverDirective {
    constructor(overlayPositionBuilder, elementRef, overlay) {
      this.overlayPositionBuilder = overlayPositionBuilder;
      this.elementRef = elementRef;
      this.overlay = overlay;
      this.popoverOnly = false; // TODO: вообще убрать внутренние стили поповера, включая отступы
      this.position = PopoverPositionEnum.bottom;
      this.showCloseButton = true;
      this.offset = OFFSET;
      this.isHint = false;
      this.isHover = false;
      this.opened = new EventEmitter();
      this.isOpened = false;
    }
    ngOnInit() {
      // Если инициализировать поповер сразу, то в DOM создаются лишние cdk-panels
    }
    ngOnChanges(changes) {
      if (changes.close && !changes.close.firstChange && changes.close.currentValue) {
        this.hide();
      }
    }
    ngOnDestroy() {
      this.hide();
    }
    onClick() {
      if (this.disabledPopover) {
        return;
      }
      if (!this.isOpened) {
        this.show();
      } else {
        this.hide();
      }
    }
    onMouseover() {
      if (!this.isHover) {
        return;
      }
      if (!this.isOpened) {
        this.show();
      } else {
        this.hide();
      }
    }
    init() {
      const positionStrategy = this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef).withLockedPosition().withPositions(generatePositions(this.position));
      this.overlayRef = this.overlay.create({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.reposition()
      });
    }
    destroy() {
      if (this.overlayRef) {
        this.overlayRef.detach();
      }
    }
    show() {
      this.init();
      this.isOpened = true;
      this.opened.emit(true);
      // Create tooltip portal
      const popoverPortal = new ComponentPortal(OnUiPopoverComponent);
      // Attach tooltip portal to overlay
      const popoverRef = this.overlayRef.attach(popoverPortal);
      // Pass content to tooltip component instance
      popoverRef.instance.content = this.content;
      popoverRef.instance.position = this.position;
      popoverRef.instance.popoverOnly = this.popoverOnly;
      popoverRef.instance.callback = isOutSide => {
        if (this.isHint && isOutSide) {
          const node = document.getSelection().anchorNode;
          if (this.overlayRef.overlayElement.contains(node)) {
            return;
          }
        }
        this.hide();
      };
    }
    hide() {
      this.isOpened = false;
      this.opened.emit(false);
      this.destroy();
    }
    static {
      this.ɵfac = function OnUiPopoverDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiPopoverDirective)(i0.ɵɵdirectiveInject(i1$3.OverlayPositionBuilder), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$3.Overlay));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: OnUiPopoverDirective,
        selectors: [["", "appPopover", ""]],
        hostBindings: function OnUiPopoverDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function OnUiPopoverDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            })("mouseover", function OnUiPopoverDirective_mouseover_HostBindingHandler($event) {
              return ctx.onMouseover($event);
            });
          }
        },
        inputs: {
          content: [0, "appPopover", "content"],
          disabledPopover: "disabledPopover",
          popoverOnly: "popoverOnly",
          position: "position",
          close: "close",
          showCloseButton: "showCloseButton",
          styles: "styles",
          offset: "offset",
          isHint: "isHint",
          isHover: "isHover"
        },
        outputs: {
          opened: "opened"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return OnUiPopoverDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiPopoverModule = /*#__PURE__*/(() => {
  class OnUiPopoverModule {
    static {
      this.ɵfac = function OnUiPopoverModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiPopoverModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiPopoverModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ClickOutsideModule]
      });
    }
  }
  return OnUiPopoverModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiTooltipComponent = /*#__PURE__*/(() => {
  class OnUiTooltipComponent {
    constructor() {
      this.text = '';
    }
    ngOnInit() {}
    static {
      this.ɵfac = function OnUiTooltipComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTooltipComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiTooltipComponent,
        selectors: [["on-ui-tooltip"]],
        inputs: {
          text: "text"
        },
        decls: 1,
        vars: 1,
        consts: [["class", "tooltip", 4, "ngIf"], [1, "tooltip"]],
        template: function OnUiTooltipComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, OnUiTooltipComponent_div_0_Template, 2, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !!ctx.text);
          }
        },
        dependencies: [i1$1.NgIf],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.tooltip[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 10px #0000001a;border-radius:10px;padding:12px}"],
        data: {
          animation: [trigger('on-ui-tooltip', [transition(':enter', [style({
            opacity: 0
          }), animate(150, style({
            opacity: 1
          }))]), transition(':leave', [animate(150, style({
            opacity: 0
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return OnUiTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** TODO на демке не работает */
let OnUiTooltipDirective = /*#__PURE__*/(() => {
  class OnUiTooltipDirective {
    constructor(overlayPositionBuilder, overlay, elementRef) {
      this.overlayPositionBuilder = overlayPositionBuilder;
      this.overlay = overlay;
      this.elementRef = elementRef;
      this.text = '';
    }
    ngOnInit() {
      const positionStrategy = this.overlayPositionBuilder.flexibleConnectedTo(this.elementRef).withPositions([{
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 0
      }]);
      this.overlayRef = this.overlay.create({
        positionStrategy,
        scrollStrategy: this.overlay.scrollStrategies.reposition()
      });
    }
    show() {
      const tooltipRef = this.overlayRef.attach(new ComponentPortal(OnUiTooltipComponent));
      tooltipRef.instance.text = this.text;
    }
    hide() {
      this.overlayRef.detach();
    }
    static {
      this.ɵfac = function OnUiTooltipDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTooltipDirective)(i0.ɵɵdirectiveInject(i1$3.OverlayPositionBuilder), i0.ɵɵdirectiveInject(i1$3.Overlay), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: OnUiTooltipDirective,
        selectors: [["", "appTooltip", ""]],
        hostBindings: function OnUiTooltipDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseenter", function OnUiTooltipDirective_mouseenter_HostBindingHandler() {
              return ctx.show();
            })("mouseleave", function OnUiTooltipDirective_mouseleave_HostBindingHandler() {
              return ctx.hide();
            });
          }
        },
        inputs: {
          text: [0, "appTooltip", "text"]
        }
      });
    }
  }
  return OnUiTooltipDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiTooltipModule = /*#__PURE__*/(() => {
  class OnUiTooltipModule {
    static {
      this.ɵfac = function OnUiTooltipModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTooltipModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiTooltipModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return OnUiTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiFormFieldErrorComponent = /*#__PURE__*/(() => {
  class OnUiFormFieldErrorComponent extends ChangableComponent {
    constructor(cdr, platform) {
      super(cdr, platform);
      this.cdr = cdr;
      this.platform = platform;
    }
    static {
      this.ɵfac = function OnUiFormFieldErrorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiFormFieldErrorComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiFormFieldErrorComponent,
        selectors: [["on-ui-form-field-error"]],
        inputs: {
          error: "error"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 3,
        vars: 1,
        consts: [[1, "on-ui-form-field-error"], [3, "ngIf"], [1, "error"]],
        template: function OnUiFormFieldErrorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, OnUiFormFieldErrorComponent_ng_template_2_Template, 3, 3, "ng-template", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.error);
          }
        },
        dependencies: [i1$1.NgIf, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-form-field-error[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:5px 0 0;color:#a4b0c3;font-size:12px;line-height:16px;color:#e86f79;display:inline-block;animation:_ngcontent-%COMP%_ascent .2s ease-in-out}@keyframes _ngcontent-%COMP%_ascent{0%{height:0;opacity:0}to{height:100%;opacity:1}}"],
        changeDetection: 0
      });
    }
  }
  return OnUiFormFieldErrorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiFormFieldErrorModule = /*#__PURE__*/(() => {
  class OnUiFormFieldErrorModule {
    static {
      this.ɵfac = function OnUiFormFieldErrorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiFormFieldErrorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiFormFieldErrorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return OnUiFormFieldErrorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiTextareaComponent = /*#__PURE__*/(() => {
  class OnUiTextareaComponent extends ChangableComponent {
    constructor(cdr) {
      super(cdr);
      this.cdr = cdr;
      this.placeholder = '';
      this.maxlength = 2000;
      this.height = 170;
      this.minHeight = 170;
      this.rows = 2;
      this.error = false;
      this.changed = new EventEmitter();
      this.formControl = new UntypedFormControl();
      this.value = '';
      this.textHeight = 0;
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {
      this.formControl.valueChanges.pipe(filter(value => value !== this.value)).pipe(takeUntil(this.destroyed$)).subscribe(value => {
        this.value = value;
        this.propagateChange(value);
        this.changed.emit(value);
      });
    }
    writeValue(value) {
      this.value = value;
      this.formControl.setValue(value);
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onBlur() {
      this.propagateTouched();
    }
    static {
      this.ɵfac = function OnUiTextareaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTextareaComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiTextareaComponent,
        selectors: [["on-ui-textarea"]],
        inputs: {
          placeholder: "placeholder",
          maxlength: "maxlength",
          height: "height",
          minHeight: "minHeight",
          rows: "rows",
          error: "error"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiTextareaComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 15,
        consts: [[1, "textarea"], ["autosize", "", "type", "text", 1, "input", 3, "blur", "formControl", "ngStyle", "placeholder"], [1, "counter"]],
        template: function OnUiTextareaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "textarea", 1);
            i0.ɵɵlistener("blur", function OnUiTextareaComponent_Template_textarea_blur_1_listener() {
              return ctx.onBlur();
            });
            i0.ɵɵtext(2, "  ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "span", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.isDisabled)("error", ctx.error);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formControl", ctx.formControl)("ngStyle", i0.ɵɵpureFunction2(12, _c7, ctx.height + "px", ctx.minHeight + "px"))("placeholder", ctx.placeholder);
            i0.ɵɵattribute("rows", ctx.rows)("maxlength", ctx.maxlength)("disabled", ctx.isDisabled ? true : null);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", (ctx.value == null ? null : ctx.value.length) || 0, " / ", ctx.maxlength, "");
          }
        },
        dependencies: [i1$1.NgStyle, i5$1.DefaultValueAccessor, i5$1.NgControlStatus, i5$1.FormControlDirective, i3$2.AutosizeDirective],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.textarea[_ngcontent-%COMP%]{border:1px solid #EEEEEE;border-radius:10px;box-sizing:border-box;display:flex;flex-direction:column;padding:15px;transition:all .2s linear}.textarea[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.textarea[_ngcontent-%COMP%]:focus-within{border-color:#5ab3e4}.textarea[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;border:none;outline:none;overflow:hidden;padding:0;resize:none;word-break:break-word;width:100%}.textarea[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled{color:#ccc}.textarea[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]::placeholder{color:#ccc}.textarea[_ngcontent-%COMP%]   .counter[_ngcontent-%COMP%]{color:#1e252b;font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:12px;line-height:16px;color:#ccc;text-align:right}.textarea.disabled[_ngcontent-%COMP%]{background:#f6f6f6;color:#ccc}.textarea.error[_ngcontent-%COMP%]{border:1px solid #E86F79}"],
        changeDetection: 0
      });
    }
  }
  return OnUiTextareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiTextareaModule = /*#__PURE__*/(() => {
  class OnUiTextareaModule {
    static {
      this.ɵfac = function OnUiTextareaModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTextareaModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiTextareaModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, AutosizeModule]
      });
    }
  }
  return OnUiTextareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiTabsComponent = /*#__PURE__*/(() => {
  class OnUiTabsComponent extends ChangableComponent {
    constructor(location, deviceService, cdr, platform) {
      super(cdr, platform);
      this.location = location;
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.platform = platform;
      this.isTabsFixed = false;
      this.displayMode = 'default';
      this.changed = new EventEmitter();
      this.svgsetIcon = IconsService.svgsetIconUrl;
    }
    set tabs(tabs) {
      this._tabs = tabs;
      this.activeTab = this.tabs[0];
    }
    get tabs() {
      return this._tabs;
    }
    get isMobile() {
      return this.deviceService.isMobile();
    }
    get isTablet() {
      return this.deviceService.isTablet();
    }
    ngOnInit() {
      //
    }
    onTabChange(tab) {
      this.activeTab = tab;
      this.changed.emit(this.activeTab);
    }
    // Device
    isActive(tab) {
      const path = this.location.path();
      switch (tab.routeMatch) {
        case 'start':
          return path.startsWith(tab.route);
        case 'end':
          return path.endsWith(tab.route);
        case 'includes':
          return path.indexOf(tab.route) > -1;
        case 'regexp':
          return false;
        // TODO
        case 'withDecode':
          return decodeURIComponent(path) === tab.route;
        case 'full':
        default:
          return path === tab.route;
      }
    }
    checkCondition(event, tab) {
      if (tab.routeCondition) {
        event.preventDefault();
        event.cancelBubble = true;
        tab.routeCondition(tab);
      }
      this.detectDataChanges();
    }
    detectDataChanges() {
      if (this.cdr && !this.cdr.destroyed) {
        this.cdr.markForCheck();
      }
    }
    static {
      this.ɵfac = function OnUiTabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTabsComponent)(i0.ɵɵdirectiveInject(i1$1.Location), i0.ɵɵdirectiveInject(i1$2.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiTabsComponent,
        selectors: [["on-ui-tabs"]],
        inputs: {
          isTabsFixed: "isTabsFixed",
          displayMode: "displayMode",
          tabs: "tabs"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 5,
        consts: [[1, "on-ui-tab"], [1, "tabs"], ["class", "tab-item", 4, "ngFor", "ngForOf"], [1, "tab-item"], [1, "tab", 3, "routerLink"], [1, "tab__name", "normal", 3, "click"], [4, "ngIf"], ["class", "tab__icon", 4, "ngIf"], [1, "tab__icon"]],
        template: function OnUiTabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
            i0.ɵɵtemplate(2, OnUiTabsComponent_li_2_Template, 7, 8, "li", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("delimiter", ctx.displayMode === "delimiter")("fixed", ctx.isTabsFixed);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.tabs);
          }
        },
        dependencies: [i1$1.NgForOf, i1$1.NgIf, i4.RouterLink, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.on-ui-tab[_ngcontent-%COMP%]{overflow:auto hidden;-ms-overflow-style:none;scrollbar-width:none}.on-ui-tab[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]{align-items:center;border:none;border-bottom:1px solid #EEEEEE;display:flex;margin:0;padding:0;min-width:fit-content}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]{list-style-type:none;margin:0 32px -1px 0}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]:last-child{margin-right:0}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]{text-decoration:none;position:relative}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__name[_ngcontent-%COMP%]{border-top:solid 2px transparent;border-bottom:2px solid transparent;border-left:none;border-right:none;background:#fff0;box-sizing:border-box;cursor:pointer;transition:all .2s linear;-webkit-user-select:none;user-select:none;position:relative;outline:none;color:#5f6d7a;font-size:14px;line-height:30px;text-decoration:none;white-space:nowrap}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__icon[_ngcontent-%COMP%]{width:18px;height:18px;position:absolute;top:-10px;right:-18px}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__border[_ngcontent-%COMP%]{border-bottom:2px solid #5ab3e4;width:100%;position:absolute;bottom:-1px;display:none}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]:hover   .tab__name[_ngcontent-%COMP%]{color:#41a1d9;border-bottom:2px solid #EEEEEE}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%]   .tab__name[_ngcontent-%COMP%]{color:#41a1d9;border-bottom:solid 2px #5ab3e4}.on-ui-tab[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%]:hover   .tab__name[_ngcontent-%COMP%]{border-bottom:2px solid #5ab3e4}.on-ui-tab.fixed[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]{position:fixed;left:0;right:0;width:100%;overflow-x:auto;background:#fff;z-index:80}.on-ui-tab.delimiter[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]{border-bottom-color:transparent}.on-ui-tab.delimiter[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]{margin:0}.on-ui-tab.delimiter[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab__name[_ngcontent-%COMP%]{border-bottom:2px solid transparent;border-left:1px solid #EEEEEE;line-height:14px;padding:0 15px}.on-ui-tab.delimiter[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab[_ngcontent-%COMP%]:hover   .tab__name[_ngcontent-%COMP%]{border-bottom:2px solid transparent}.on-ui-tab.delimiter[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%]   .tab__name[_ngcontent-%COMP%]{border-bottom:solid 2px transparent}.on-ui-tab.delimiter[_ngcontent-%COMP%]   .tabs[_ngcontent-%COMP%]   .tab-item[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%]:hover   .tab__name[_ngcontent-%COMP%]{border-bottom:2px solid transparent}"],
        changeDetection: 0
      });
    }
  }
  return OnUiTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiTabsModule = /*#__PURE__*/(() => {
  class OnUiTabsModule {
    static {
      this.ɵfac = function OnUiTabsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiTabsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiTabsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, TranslateModule]
      });
    }
  }
  return OnUiTabsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiDateComponent = /*#__PURE__*/(() => {
  class OnUiDateComponent {
    constructor(dateAdapter) {
      this.dateAdapter = dateAdapter;
      this.placeholder = 'DD MM YYYY';
      this.startView = 'month';
      this.inputDisplayed = true;
      this.changed = new EventEmitter();
      this.closed = new EventEmitter();
      this.onMonthSelect = new EventEmitter();
      this.locale = 'en-GB';
      this.svgsetIconUrl = IconsService.svgsetIconUrl;
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {
      this.dateAdapter.getFirstDayOfWeek = () => {
        let weekDay = 0;
        try {
          weekDay = getLocaleFirstDayOfWeek(this.locale);
        } catch (e) {
          console.warn(e);
        }
        return weekDay;
      };
    }
    get inputValue() {
      return this.value ? new Date(this.value) : null;
    }
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    onChanged(event) {
      const value = event.value || null;
      this.value = value;
      this.propagateChange(value);
      this.changed.emit(value);
    }
    onOpened() {
      this.isOpened = true;
    }
    onClosed() {
      this.isOpened = false;
      this.propagateTouched();
      this.closed.emit();
    }
    onMonthSelected(value, datepicker) {
      if (this.onlyYearAndMonth) {
        this.value = value;
        this.propagateChange(value);
        this.onMonthSelect.emit(value);
        datepicker.close();
      }
    }
    static {
      this.ɵfac = function OnUiDateComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiDateComponent)(i0.ɵɵdirectiveInject(i3$1.DateAdapter));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiDateComponent,
        selectors: [["on-ui-date"]],
        viewQuery: function OnUiDateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c8, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.picker = _t.first);
          }
        },
        inputs: {
          placeholder: "placeholder",
          min: "min",
          max: "max",
          startView: "startView",
          inputDisplayed: "inputDisplayed",
          onlyYearAndMonth: "onlyYearAndMonth",
          locale: "locale"
        },
        outputs: {
          changed: "changed",
          closed: "closed",
          onMonthSelect: "onMonthSelect"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiDateComponent),
          multi: true
        }])],
        ngContentSelectors: _c2,
        decls: 5,
        vars: 8,
        consts: [["picker", ""], [1, "date"], [4, "ngIf"], [3, "closed", "monthSelected", "opened", "startView", "disabled"], [1, "label"], ["type", "text", "readonly", "", 1, "input", 3, "dateChange", "click", "matDatepicker", "value", "min", "max", "placeholder"], ["width", "12", "height", "7", 1, "icon"], [1, "no-input", 3, "dateChange", "click", "matDatepicker", "value", "min", "max"]],
        template: function OnUiDateComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, OnUiDateComponent_ng_container_1_Template, 5, 7, "ng-container", 2)(2, OnUiDateComponent_ng_container_2_Template, 4, 4, "ng-container", 2);
            i0.ɵɵelementStart(3, "mat-datepicker", 3, 0);
            i0.ɵɵlistener("closed", function OnUiDateComponent_Template_mat_datepicker_closed_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClosed());
            })("monthSelected", function OnUiDateComponent_Template_mat_datepicker_monthSelected_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              const picker_r4 = i0.ɵɵreference(4);
              return i0.ɵɵresetView(ctx.onMonthSelected($event, picker_r4));
            })("opened", function OnUiDateComponent_Template_mat_datepicker_opened_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOpened());
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("opened", ctx.isOpened)("disabled", ctx.isDisabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.inputDisplayed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.inputDisplayed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("startView", ctx.startView)("disabled", ctx.isDisabled);
          }
        },
        dependencies: [i1$1.NgIf, i3$3.MatDatepicker, i3$3.MatDatepickerInput],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.date[_ngcontent-%COMP%]{position:relative}.date[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{display:flex}.date[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{stroke:#a4b0c3;position:absolute;right:12px;top:14px;transform:rotate(180deg);transition:all .2s linear}.date[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;appearance:none;color:#1e252b;background:#fff;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;height:34px;outline:none;padding:0 10px;transition:border-color .2s linear;width:100%}.date[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.date[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]::placeholder{color:#ccc}.date.disabled[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{stroke:#ccc}.date.disabled[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{background:#f6f6f6;color:#ccc}.date.opened[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{border-color:#5ab3e4}.date.opened[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{stroke:#5ab3e4;transform:rotate(0);transition:all .2s linear}.date[_ngcontent-%COMP%]   .no-input[_ngcontent-%COMP%]{height:100%;margin:0;padding:0;border:none;width:0}.field_error[_nghost-%COMP%]   input[_ngcontent-%COMP%], .field_error   [_nghost-%COMP%]   input[_ngcontent-%COMP%]{border:1px solid #E86F79}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}"]
      });
    }
  }
  return OnUiDateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiDateModule = /*#__PURE__*/(() => {
  class OnUiDateModule {
    static {
      this.ɵfac = function OnUiDateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiDateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiDateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatDatepickerModule, MatNativeDateModule]
      });
    }
  }
  return OnUiDateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiProgressBarComponent = /*#__PURE__*/(() => {
  class OnUiProgressBarComponent extends ChangableComponent {
    constructor(deviceService, cdr, platform) {
      super(cdr, platform);
      this.deviceService = deviceService;
      this.cdr = cdr;
      this.platform = platform;
    }
    get show() {
      return this.value > 0 && this.value < 100;
    }
    get valueCeil() {
      return Math.floor(this.value);
    }
    static {
      this.ɵfac = function OnUiProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiProgressBarComponent)(i0.ɵɵdirectiveInject(i1$2.DeviceDetectorService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiProgressBarComponent,
        selectors: [["on-ui-progress-bar"]],
        inputs: {
          value: "value"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 10,
        consts: [[1, "custom-progress-bar"], [3, "mode", "value"]],
        template: function OnUiProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "mat-progress-bar", 1);
            i0.ɵɵelementStart(5, "span");
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("show", ctx.show)("mobile", !ctx.deviceService.isDesktop());
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 8, "loading"), "...");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mode", "determinate")("value", ctx.value);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", ctx.valueCeil, "%");
          }
        },
        dependencies: [i3$4.MatProgressBar, i3.TranslatePipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.custom-progress-bar[_ngcontent-%COMP%]{width:280px;padding:10px 15px;border-radius:10px;box-shadow:0 0 30px #0000001a;transition:all .2s linear;background:#fff;display:flex;flex-direction:column;align-items:center;position:fixed;z-index:9999;bottom:30px;left:0;right:0;margin:0 auto;gap:10px;opacity:0;visibility:hidden}.custom-progress-bar.show[_ngcontent-%COMP%]{visibility:visible;opacity:1;bottom:35px}.custom-progress-bar.mobile[_ngcontent-%COMP%]{bottom:100px}.custom-progress-bar.mobile.show[_ngcontent-%COMP%]{bottom:105px}.custom-progress-bar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;color:#a4b0c3;font-size:14px;line-height:18px;color:#1e252b}"],
        changeDetection: 0
      });
    }
  }
  return OnUiProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiProgressBarModule = /*#__PURE__*/(() => {
  class OnUiProgressBarModule {
    static {
      this.ɵfac = function OnUiProgressBarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiProgressBarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiProgressBarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, MatProgressBar]
      });
    }
  }
  return OnUiProgressBarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatAutocompleteTriggerAccessorDirective = /*#__PURE__*/(() => {
  class MatAutocompleteTriggerAccessorDirective {
    constructor(_refTrigger) {
      this._refTrigger = _refTrigger;
    }
    ngOnInit() {
      if (this._refTrigger === undefined || this._refTrigger === null) {
        return;
      }
      this._refTrigger['_scrollToOption'] = this._scrollToOption.bind(this._refTrigger, this.optionHeight, this.panelHeight);
    }
    _scrollToOption(optionHeight, panelHeight) {
      const index = this.autocomplete._keyManager.activeItemIndex || 0;
      const labelCount = _countGroupLabelsBeforeOption(index, this.autocomplete.options, this.autocomplete.optionGroups);
      if (index === 0 && labelCount === 1) {
        this.autocomplete._setScrollTop(0);
      } else {
        const newScrollPosition = _getOptionScrollPosition(index + labelCount, optionHeight, this.autocomplete._getScrollTop(), panelHeight);
        this.autocomplete._setScrollTop(newScrollPosition);
      }
    }
    static {
      this.ɵfac = function MatAutocompleteTriggerAccessorDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatAutocompleteTriggerAccessorDirective)(i0.ɵɵdirectiveInject(i1$4.MatAutocompleteTrigger, 11));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MatAutocompleteTriggerAccessorDirective,
        selectors: [["", "appMatAutocompleteTriggerAccessor", ""]],
        inputs: {
          optionHeight: "optionHeight",
          panelHeight: "panelHeight"
        }
      });
    }
  }
  return MatAutocompleteTriggerAccessorDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HighlightPipe = /*#__PURE__*/(() => {
  class HighlightPipe {
    transform(value, search) {
      if (!search) {
        return value;
      }
      const re = new RegExp(search, 'gi');
      return value.replace(re, match => '<b>' + match + '</b>');
    }
    static {
      this.ɵfac = function HighlightPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HighlightPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "highlight",
        type: HighlightPipe,
        pure: true
      });
    }
  }
  return HighlightPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiAutocompleteComponent = /*#__PURE__*/(() => {
  class OnUiAutocompleteComponent extends ChangableComponent {
    set options(options) {
      this._options = options;
      this.updateFormControl();
    }
    set selected(value) {
      this.writeValue(value);
    }
    constructor(cdr, platform) {
      super(cdr, platform);
      this.cdr = cdr;
      this.platform = platform;
      // @Input() options: IControlOption[];
      this.placeholder = 'Pick one';
      this.error = false;
      this.changed = new EventEmitter();
      this.formControl = new UntypedFormControl();
      this.svgsetIconUrl = IconsService.svgsetIconUrl;
      this.search = this.register(new Subject());
      this.search$ = this.search.asObservable();
      this._options = [];
      this.propagateChange = () => {};
      this.propagateTouched = () => {};
    }
    ngOnInit() {
      this.filteredOptions$ = this.formControl.valueChanges.pipe(startWith(''), filter$1(value => typeof value === 'string' || typeof value === 'object'), map(value => typeof value === 'string' ? value : value.title), map(title => title ? this.filter(title) : this._options.slice()));
      this.search$.pipe(distinctUntilChanged(), debounceTime(250), filter$1(() => !!this.selectedValue)).pipe(takeUntil$1(this.destroyed$)).subscribe(() => {
        this.selectedValue = null;
        this.propagateChange(this.selectedValue);
        this.changed.emit(this.selectedValue);
      });
    }
    filter(value) {
      const filterValue = value.toLowerCase();
      return this._options.filter(option => option.title.toLowerCase().includes(filterValue));
    }
    updateFormControl() {
      const selectedOption = this._options.find(option => option.value === this.selectedValue);
      this.formControl.setValue(selectedOption || '');
    }
    writeValue(value) {
      this.selectedValue = value;
      this.updateFormControl();
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      this.propagateTouched = fn;
    }
    setDisabledState(isDisabled) {
      if (isDisabled) {
        this.formControl.disable();
      } else {
        this.formControl.enable();
      }
      this.cdr.markForCheck();
    }
    displayFn(option) {
      return option ? option.title : undefined;
    }
    onBlur() {
      this.propagateTouched();
    }
    onOpened() {
      this.isOpened = true;
    }
    onClosed() {
      this.isOpened = false;
    }
    onKeyup(value, keyCode) {
      if (keyCode !== 13) {
        // ignore Enter
        this.search.next(value);
      }
    }
    onSelected(event) {
      this.selectedValue = event.option.value.value;
      this.propagateChange(this.selectedValue);
      this.changed.emit(this.selectedValue);
    }
    trackByFn(id, option) {
      return option.value;
    }
    static {
      this.ɵfac = function OnUiAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiAutocompleteComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlatformService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiAutocompleteComponent,
        selectors: [["on-ui-autocomplete"]],
        inputs: {
          options: "options",
          selected: "selected",
          placeholder: "placeholder",
          error: "error"
        },
        outputs: {
          changed: "changed"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => OnUiAutocompleteComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 17,
        consts: [["search", ""], ["auto", "matAutocomplete"], [1, "autocomplete"], ["width", "12", "height", "7", 1, "icon"], ["type", "text", "appMatAutocompleteTriggerAccessor", "", 1, "input", 3, "keyup", "blur", "placeholder", "formControl", "matAutocomplete", "optionHeight"], [3, "optionSelected", "closed", "opened", "displayWith"], [3, "value", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "value"], [3, "innerHTML"]],
        template: function OnUiAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "label", 2);
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(1, "svg", 3);
            i0.ɵɵelement(2, "use");
            i0.ɵɵelementEnd();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(3, "input", 4, 0);
            i0.ɵɵlistener("keyup", function OnUiAutocompleteComponent_Template_input_keyup_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyup($event.target.value, $event.keyCode));
            })("blur", function OnUiAutocompleteComponent_Template_input_blur_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onBlur());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "mat-autocomplete", 5, 1);
            i0.ɵɵlistener("optionSelected", function OnUiAutocompleteComponent_Template_mat_autocomplete_optionSelected_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelected($event));
            })("closed", function OnUiAutocompleteComponent_Template_mat_autocomplete_closed_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClosed());
            })("opened", function OnUiAutocompleteComponent_Template_mat_autocomplete_opened_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onOpened());
            });
            i0.ɵɵtemplate(7, OnUiAutocompleteComponent_mat_option_7_Template, 3, 5, "mat-option", 6);
            i0.ɵɵpipe(8, "async");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const auto_r4 = i0.ɵɵreference(6);
            i0.ɵɵclassProp("opened", ctx.isOpened)("disabled", ctx.formControl.disabled)("error", ctx.error);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("href", ctx.svgsetIconUrl("chevron-up"), null, "xlink");
            i0.ɵɵadvance();
            i0.ɵɵproperty("placeholder", ctx.placeholder)("formControl", ctx.formControl)("matAutocomplete", auto_r4)("optionHeight", 26);
            i0.ɵɵattribute("disabled", ctx.formControl.disabled ? true : null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("displayWith", ctx.displayFn);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(8, 15, ctx.filteredOptions$))("ngForTrackBy", ctx.trackByFn);
          }
        },
        dependencies: [i1$1.NgForOf, i1$4.MatAutocomplete, i3$1.MatOption, i1$4.MatAutocompleteTrigger, i5$1.DefaultValueAccessor, i5$1.NgControlStatus, i5$1.FormControlDirective, MatAutocompleteTriggerAccessorDirective, i1$1.AsyncPipe, HighlightPipe],
        styles: ["@charset \"UTF-8\";@font-face{font-family:LatoWebBold;font-display:swap;src:url(/assets/fonts/Lato-Bold.eot);src:url(/assets/fonts/Lato-Bold.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Bold.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Bold.woff) format(\"woff\"),url(/assets/fonts/Lato-Bold.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWebMedium;font-display:swap;src:url(/assets/fonts/Lato-Medium.eot);src:url(/assets/fonts/Lato-Medium.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Medium.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Medium.woff) format(\"woff\"),url(/assets/fonts/Lato-Medium.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}@font-face{font-family:LatoWeb;font-display:swap;src:url(/assets/fonts/Lato-Regular.eot);src:url(/assets/fonts/Lato-Regular.eot?#iefix) format(\"embedded-opentype\"),url(/assets/fonts/Lato-Regular.woff2) format(\"woff2\"),url(/assets/fonts/Lato-Regular.woff) format(\"woff\"),url(/assets/fonts/Lato-Regular.ttf) format(\"truetype\");font-style:normal;font-weight:400;text-rendering:optimizeLegibility}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select){background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option[_ngcontent-%COMP%]:hover{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.mat-autocomplete-panel[_ngcontent-%COMP%]:not(.multi-select)   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]{background:#fff;border-radius:10px;padding:10px 0;box-shadow:0 0 10px #0000001a!important;width:calc(100% + 3px)!important;min-width:100%!important;left:0;position:relative;top:5px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;color:#1e252b;height:30px;line-height:26px;cursor:pointer;padding:0 10px}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option[_ngcontent-%COMP%]:hover, .multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-active[_ngcontent-%COMP%]{background:#5ab3e4!important;color:#fff!important}.multi-select.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-mdc-option.mat-mdc-option-disabled[_ngcontent-%COMP%]{color:#a4b0c3}.mat-datepicker-content[_ngcontent-%COMP%]{border-radius:10px!important;box-shadow:0 0 10px #0000001a!important;margin-top:5px;font-family:serif}.autocomplete[_ngcontent-%COMP%]{display:block;position:relative}.autocomplete[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{font-family:LatoWeb,sans-serif;font-weight:inherit;margin:0;font-size:16px;line-height:24px;appearance:none;color:#1e252b;border:1px solid #EEEEEE;box-sizing:border-box;border-radius:10px;height:34px;line-height:30px;outline:none;padding:0 30px 0 10px;transition:border-color .2s linear;width:100%}.autocomplete[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:hover{border-color:#a4b0c3}.autocomplete[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]::placeholder{color:#ccc}.autocomplete[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]:disabled{background:#f6f6f6;color:#ccc}.autocomplete[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{stroke:#a4b0c3;position:absolute;right:12px;top:14px;transform:rotate(180deg);transition:all .2s linear}.autocomplete.disabled[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{background:#f6f6f6;color:#ccc}.autocomplete.disabled[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{stroke:#ccc}.autocomplete.disabled[_ngcontent-%COMP%]   .mat-select-value[_ngcontent-%COMP%]{color:#ccc}.autocomplete.opened[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{border-color:#5ab3e4}.autocomplete.opened[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{stroke:#5ab3e4;transform:rotate(0);transition:all .2s linear}.autocomplete.error[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{border-color:#e86f79}"],
        changeDetection: 0
      });
    }
  }
  return OnUiAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiAutocompleteModule = /*#__PURE__*/(() => {
  class OnUiAutocompleteModule {
    static {
      this.ɵfac = function OnUiAutocompleteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiAutocompleteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiAutocompleteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatAutocompleteModule, ReactiveFormsModule]
      });
    }
  }
  return OnUiAutocompleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const audioPlayerDefaultConfig = {
  autoPlay: false,
  displayTitle: false,
  displayVolumeSlider: true,
  displayRepeatControls: false,
  disablePositionSlider: false,
  displayDuration: false,
  repeat: 'none',
  singleTrack: [{
    title: '',
    link: ''
  }]
};
let OnUiAudioPlayerComponent = /*#__PURE__*/(() => {
  class OnUiAudioPlayerComponent extends ChangableComponent {
    constructor(cdr) {
      super(cdr);
      this.cdr = cdr;
      this.audioPlayerConfig = audioPlayerDefaultConfig;
      this.trackPlaying = new EventEmitter();
      this.trackPaused = new EventEmitter();
      this.trackEnded = new EventEmitter();
      this.trackSelected = new EventEmitter();
      this.nextTrackRequested = new EventEmitter();
      this.previousTrackRequested = new EventEmitter();
    }
    ngAfterViewInit() {
      this.audioPlayer.volume = 0.5;
      this.detectChanges();
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      clearInterval(this.intervalId);
    }
    onPlaying(event) {
      this.trackPlaying.emit(event);
      this.intervalId = setInterval(() => this.detectChanges(), 300);
    }
    onPause(event) {
      this.trackPaused.emit(event);
    }
    onStop(event) {
      this.trackEnded.emit(event);
      clearInterval(this.intervalId);
    }
    onTrackSelected(event) {
      this.trackSelected.emit(event);
    }
    onNextTrackRequested(event) {
      this.nextTrackRequested.emit(event);
    }
    onPreviousTrackRequested(event) {
      this.previousTrackRequested.emit(event);
    }
    play() {
      this.audioPlayer.play();
    }
    pause() {
      this.audioPlayer.pause();
      clearInterval(this.intervalId);
    }
    stop() {
      this.audioPlayer.stop();
      clearInterval(this.intervalId);
    }
    muted() {
      this.audioPlayer.muted();
    }
    unMuted() {
      this.audioPlayer.unMuted();
    }
    toggleVolume() {
      this.audioPlayer.toggleVolume();
    }
    forward(time_diff) {
      this.audioPlayer.forward(time_diff);
      this.detectChanges();
    }
    rewind(time_diff) {
      this.audioPlayer.rewind(time_diff);
      this.detectChanges();
    }
    static {
      this.ɵfac = function OnUiAudioPlayerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiAudioPlayerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OnUiAudioPlayerComponent,
        selectors: [["on-ui-audio-player"]],
        viewQuery: function OnUiAudioPlayerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c9, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.audioPlayer = _t.first);
          }
        },
        inputs: {
          audioPlayerConfig: "audioPlayerConfig"
        },
        outputs: {
          trackPlaying: "trackPlaying",
          trackPaused: "trackPaused",
          trackEnded: "trackEnded",
          trackSelected: "trackSelected",
          nextTrackRequested: "nextTrackRequested",
          previousTrackRequested: "previousTrackRequested"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 8,
        consts: [["audioPlayer", ""], [3, "trackPlaying", "trackPaused", "trackEnded", "trackSelected", "nextTrackRequested", "previousTrackRequested", "autoPlay", "displayTitle", "displayVolumeSlider", "displayRepeatControls", "disablePositionSlider", "displayDuration", "playlist", "repeat"]],
        template: function OnUiAudioPlayerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "ngx-audio-player", 1, 0);
            i0.ɵɵlistener("trackPlaying", function OnUiAudioPlayerComponent_Template_ngx_audio_player_trackPlaying_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPlaying($event));
            })("trackPaused", function OnUiAudioPlayerComponent_Template_ngx_audio_player_trackPaused_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPause($event));
            })("trackEnded", function OnUiAudioPlayerComponent_Template_ngx_audio_player_trackEnded_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onStop($event));
            })("trackSelected", function OnUiAudioPlayerComponent_Template_ngx_audio_player_trackSelected_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTrackSelected($event));
            })("nextTrackRequested", function OnUiAudioPlayerComponent_Template_ngx_audio_player_nextTrackRequested_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onNextTrackRequested($event));
            })("previousTrackRequested", function OnUiAudioPlayerComponent_Template_ngx_audio_player_previousTrackRequested_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPreviousTrackRequested($event));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("autoPlay", ctx.audioPlayerConfig.autoPlay)("displayTitle", ctx.audioPlayerConfig.displayTitle)("displayVolumeSlider", ctx.audioPlayerConfig.displayVolumeSlider)("displayRepeatControls", ctx.audioPlayerConfig.displayRepeatControls)("disablePositionSlider", ctx.audioPlayerConfig.disablePositionSlider)("displayDuration", ctx.audioPlayerConfig.displayDuration)("playlist", ctx.audioPlayerConfig.singleTrack)("repeat", ctx.audioPlayerConfig.repeat);
          }
        },
        dependencies: [i1$5.AudioPlayerComponent],
        styles: ["[_nghost-%COMP%]{width:100%}ngx-audio-player[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{box-sizing:border-box!important}ngx-audio-player[_ngcontent-%COMP%]{width:100%}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player{box-shadow:none;border:none}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player>.ngx-col{padding-left:10px;padding-right:10px}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.play-pause, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.volume{border:none;display:flex;justify-content:center;align-items:center}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.play-pause .mat-button-wrapper, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.volume .mat-button-wrapper{width:32px;height:32px;display:flex;justify-content:center;align-items:center}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.play-pause .mat-button-wrapper .volume-up, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.play-pause .mat-button-wrapper .volume-mute, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.volume .mat-button-wrapper .volume-up, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.volume .mat-button-wrapper .volume-mute{flex-shrink:0;width:32px!important;height:32px!important;display:flex;justify-content:center;align-items:center}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.play-pause .mat-button-ripple, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.volume .mat-button-ripple{display:none}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.play-pause .mat-button-focus-overlay, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player button.volume .mat-button-focus-overlay{display:none}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .play-pause{width:42px;height:42px;flex-grow:0;flex-shrink:0;min-width:42px;border-radius:100%;background-color:#e6f6ff}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .play-pause .mat-icon{fill:#5ab3e4;transition:all .2s;margin:0}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .play-pause:hover{background:#5ab3e4}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .play-pause:hover .mat-icon{fill:#fff;transition:all .2s}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .volume .volume-up, ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .volume .volume-mute{display:none}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .volume .mat-button-wrapper{width:110px!important;gap:5px}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .volume .mat-icon{fill:#5ab3e4;transition:all .2s;border-radius:5px}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .ngx-flex-fill .ngx-py-3.ngx-px-1{color:#1e252b;line-height:13px;padding:.25rem!important}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player .ngx-flex-fill .ngx-py-3.ngx-px-1:last-child{display:none}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player mat-slider.ngx-volume{margin-top:0;height:48px;min-width:68px}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player mat-slider.mat-slider .mat-slider-wrapper{height:3px;top:22px}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player mat-slider.mat-slider .mat-slider-wrapper .mat-slider-track-wrapper{height:3px;border-radius:2px}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player mat-slider.mat-slider .mat-slider-wrapper .mat-slider-track-wrapper .mat-slider-track-fill{height:3px;background:#5ab3e4}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player mat-slider.mat-slider .mat-slider-wrapper .mat-slider-track-wrapper .mat-slider-track-background{height:3px;background:#eee}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player mat-slider.mat-slider .mat-slider-thumb{box-shadow:unset;height:18px;width:18px;background-color:#fff;border:3px solid #5AB3E4;box-sizing:border-box;transform:scale(1);right:-9px;bottom:-9px}@media screen and (max-width: 768px){ngx-audio-player[_ngcontent-%COMP%]{width:100%}ngx-audio-player[_ngcontent-%COMP%]     .ngx-audio-player{min-width:auto}ngx-audio-player[_ngcontent-%COMP%]     .ngx-d-none{display:block!important}}"],
        changeDetection: 0
      });
    }
  }
  return OnUiAudioPlayerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OnUiAudioPlayerModule = /*#__PURE__*/(() => {
  class OnUiAudioPlayerModule {
    static {
      this.ɵfac = function OnUiAudioPlayerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OnUiAudioPlayerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OnUiAudioPlayerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, NgxAudioPlayerModule]
      });
    }
  }
  return OnUiAudioPlayerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OnUiAudioPlayerComponent, OnUiAudioPlayerModule, OnUiAutocompleteComponent, OnUiAutocompleteModule, OnUiBulletListComponent, OnUiBulletListModule, OnUiButtonComponent, OnUiButtonModule, OnUiButtonTabComponent, OnUiButtonTabModule, OnUiCardMenuComponent, OnUiCardMenuModule, OnUiCheckboxComponent, OnUiCheckboxModule, OnUiCoverComponent, OnUiCoverModule, OnUiDateComponent, OnUiDateModule, OnUiFormFieldErrorComponent, OnUiFormFieldErrorModule, OnUiFormStepComponent, OnUiFormStepModule, OnUiInputComponent, OnUiInputModule, OnUiPopoverComponent, OnUiPopoverDirective, OnUiPopoverModule, OnUiProgressBarComponent, OnUiProgressBarModule, OnUiRadioComponent, OnUiRadioModule, OnUiReceiptComponent, OnUiReceiptModule, OnUiSelectComponent, OnUiSelectModule, OnUiSelectSearchComponent, OnUiSelectSearchModule, OnUiSpriteComponent, OnUiSpriteModule, OnUiTabsComponent, OnUiTabsModule, OnUiTextareaComponent, OnUiTextareaModule, OnUiTooltipComponent, OnUiTooltipDirective, OnUiTooltipModule, PopoverPositionEnum, audioPlayerDefaultConfig };
